import './trailingSlash.js'
import './dashboard.css'
import {
  getStoredAccountId,
  setStoredAccountId,
  clearStoredAccountId,
  setStoredAccountLabel,
  initSiteHeader,
  updateSiteHeader
} from './siteHeader'
import { mountSetupWizard } from './setupWizard'
import { renderActivityChart as paintActivityChart } from './activityChart.mjs'
import {
  buildHostedUnlockPreviewSelectionKey,
  buildHostedUnlockPreviewUrl,
  buildHostedUnlockSuccessPreviewUrl,
  isHostedUnlockPreviewRequestCurrent,
  listHostedUnlockExperimentViews,
  parseHostedUnlockExperimentView,
  selectPreviewPaymentHook
} from './unlockPreview.mjs'
import {
  FEATURE_USAGE_KEY,
  buildHostedUsagePreviewUrl,
  normalizeDashboardFeatureUsage,
  serializeDashboardFeatureUsage
} from './featureUsageSettings.mjs'
import {
  normalizeDashboardTrial,
  serializeDashboardTrial
} from './trialSettings.mjs'
import { mountSdkButtonPreview } from './buttonPreview.mjs'

const API_URL = 'https://api.payhook.link'
const STRIPE_CLIENT_ID = 'ca_JsVIlqC3LJbbx63jFeficOLYhCwpJEnA'
const SESSION_EMAIL_KEY = 'payhook:authEmail'

const connectView = document.getElementById('connect-view')
const connectTitle = document.getElementById('connect-title')
const connectLead = document.getElementById('connect-lead')
const connectPanelLead = document.getElementById('connect-panel-lead')
const authPanel = document.getElementById('auth-panel')
const authPanelLead = document.getElementById('auth-panel-lead')
const storageAccessPanel = document.getElementById('storage-access-panel')
const storageAccessBtn = document.getElementById('storage-access-btn')
const storageAccessStatus = document.getElementById('storage-access-status')
const authFormPanel = document.getElementById('auth-form-panel')
const authSentPanel = document.getElementById('auth-sent-panel')
const authSentLead = document.getElementById('auth-sent-lead')
const authForm = document.getElementById('auth-form')
const authEmailInput = document.getElementById('auth-email')
const authSubmitBtn = document.getElementById('auth-submit')
const authResendBtn = document.getElementById('auth-resend-btn')
const stripeConnectPanel = document.getElementById('stripe-connect-panel')
const dashboardView = document.getElementById('dashboard-view')
const dashboardLoading = document.getElementById('dashboard-loading')
const dashboardLoadingText = document.getElementById('dashboard-loading-text')
const dashboardLoadingRetry = document.getElementById('dashboard-loading-retry')
const dashLayout = document.getElementById('dash-layout')
const dashboardStatus = document.getElementById('dashboard-status')
const overviewStatus = document.getElementById('overview-status')
const analyticsStatus = document.getElementById('analytics-status')
const statsPanel = document.getElementById('stats-panel')
const statsGrid = document.getElementById('stats-grid')
const activityPanel = document.getElementById('activity-panel')
const activityChart = document.getElementById('activity-chart')
const activityCountriesPanel = document.getElementById('activity-countries-panel')
const activityCountriesList = document.getElementById('activity-countries-list')
const featureUsageStatsStatus = document.getElementById('feature-usage-stats-status')
const featureUsageStatsPanel = document.getElementById('feature-usage-stats-panel')
const featureUsageStatsList = document.getElementById('feature-usage-stats-list')
const featureUsageStatsCopy = document.getElementById('feature-usage-stats-copy')
const featureUsageChartPanel = document.getElementById('feature-usage-chart-panel')
const featureUsageChart = document.getElementById('feature-usage-chart')
const featureUsageChartCopy = document.getElementById('feature-usage-chart-copy')
const featureUsageCountriesPanel = document.getElementById('feature-usage-countries-panel')
const featureUsageCountriesList = document.getElementById('feature-usage-countries-list')
const featureUsageCountriesCopy = document.getElementById('feature-usage-countries-copy')
const productSalesPanel = document.getElementById('product-sales-panel')
const productSalesStatus = document.getElementById('product-sales-status')
const productSalesList = document.getElementById('product-sales-list')
const priceSalesPanel = document.getElementById('price-sales-panel')
const priceSalesList = document.getElementById('price-sales-list')
const overviewRangeSelect = document.getElementById('overview-range')
const analyticsRangeSelect = document.getElementById('analytics-range')
const salesRangeSelect = document.getElementById('sales-range')
const activityPanelCopy = document.getElementById('activity-panel-copy')
const activityCountriesCopy = document.getElementById('activity-countries-copy')
const productSalesCopy = document.getElementById('product-sales-copy')
const priceSalesCopy = document.getElementById('price-sales-copy')
const connectStripeBtn = document.getElementById('connect-stripe-btn')
const connectStatus = document.getElementById('connect-status')
const headerConnectBtn = document.getElementById('header-connect-btn')
const headerDisconnectBtn = document.getElementById('header-disconnect-btn')
const createHookBtn = document.getElementById('create-hook-btn')
const dashSidebar = document.getElementById('dash-sidebar')
const bootLoading = document.getElementById('boot-loading')
const bootLoadingText = document.getElementById('boot-loading-text')
const dashInstall = document.getElementById('dash-install')
const setupWizardEl = document.getElementById('setup-wizard')
const rightPanelPreview = document.getElementById('right-panel-preview')
const rightPanelPreviewSlot = document.getElementById('right-panel-preview-slot')
const rightPanelPreviewEmpty = document.getElementById('right-panel-preview-empty')
const rightPanelPreviewLoading = document.getElementById('right-panel-preview-loading')
const rightPanelPreviewLoadingText = document.getElementById('right-panel-preview-loading-text')
const appRail = document.getElementById('app-rail')
const workspaceSwitcher = document.getElementById('workspace-switcher')
const workspaceTrigger = document.getElementById('workspace-switcher-trigger')
const workspaceTriggerName = document.getElementById('workspace-switcher-name')
const workspaceTriggerMeta = document.getElementById('workspace-switcher-meta')
const workspaceTriggerAvatar = document.getElementById('workspace-switcher-avatar')
const workspaceMenu = document.getElementById('workspace-switcher-menu')
const workspaceOptions = document.getElementById('workspace-switcher-options')
const workspaceNewBtn = document.getElementById('workspace-new-btn')
const workspacePickerView = document.getElementById('workspace-picker-view')
const workspacePickerList = document.getElementById('workspace-picker-list')
const workspacePickerNewBtn = document.getElementById('workspace-picker-new-btn')
const workspaceCreateModal = document.getElementById('workspace-create-modal')
const workspaceCreateForm = document.getElementById('workspace-create-form')
const workspaceCreateInput = document.getElementById('workspace-create-input')
const workspaceCreateStatus = document.getElementById('workspace-create-status')
const workspaceCreateCancel = document.getElementById('workspace-create-cancel')
const workspaceCreateSubmit = document.getElementById('workspace-create-submit')
const settingsForm = document.getElementById('settings-form')
const workspaceNameInput = document.getElementById('workspace-name-input')
const workspaceExtensionInput = document.getElementById('workspace-extension-input')
const settingsStatus = document.getElementById('settings-status')
const settingsSaveBtn = document.getElementById('settings-save-btn')

const WORKSPACE_ID_KEY = 'payhook:workspaceId'

function hideBootLoading () {
  if (bootLoading) bootLoading.hidden = true
}

// ── Right panel: SETUP ↔ PREVIEW ─────────────────────────────────────────

const BUTTON_PREVIEW_IDS = ['unlock-button-preview-home']
const SUCCESS_PREVIEW_IDS = ['unlock-success-preview']

const PRODUCT_CATALOG_PREVIEW_IDS = ['unlock-preview']

const BRANDING_PREVIEW_IDS = ['email-preview']

const PRODUCT_CATALOG_TABS = ['catalog', 'features', 'text']

function normalizeCatalogTab (tab) {
  if (!tab) return null
  return PRODUCT_CATALOG_TABS.includes(tab) ? tab : null
}

const previewOrigins = new Map()
let mountedPreviewTab = null

function rememberPreviewOrigin (el) {
  if (!el?.id || !el.parentNode || el.parentNode === rightPanelPreviewSlot) return
  previewOrigins.set(el.id, { parent: el.parentNode, next: el.nextSibling })
}

function restorePreviewElement (el, origin) {
  if (!el || !origin?.parent) return
  if (el.parentNode === origin.parent) return
  if (origin.next?.parentNode === origin.parent) {
    origin.parent.insertBefore(el, origin.next)
  } else {
    origin.parent.appendChild(el)
  }
}

function restoreAllPreviews () {
  if (!rightPanelPreviewSlot) return

  ;[...rightPanelPreviewSlot.children].forEach((el) => {
    restorePreviewElement(el, previewOrigins.get(el.id))
  })
  rightPanelPreviewSlot.replaceChildren()

  previewOrigins.forEach((origin, id) => {
    restorePreviewElement(document.getElementById(id), origin)
  })
  mountedPreviewTab = null
}

function setRightPanelMode (mode) {
  if (!dashInstall) return
  dashInstall.dataset.mode = mode
  if (rightPanelPreview) rightPanelPreview.hidden = mode !== 'preview'
}

function setRightPanelPreviewLoading (isLoading, message = 'Loading preview…') {
  if (rightPanelPreview) rightPanelPreview.classList.toggle('is-loading', isLoading)
  if (rightPanelPreviewLoading) rightPanelPreviewLoading.hidden = !isLoading
  if (rightPanelPreviewLoadingText) rightPanelPreviewLoadingText.textContent = message
  if (isLoading) {
    if (rightPanelPreviewEmpty) rightPanelPreviewEmpty.hidden = true
    if (rightPanelPreviewSlot) rightPanelPreviewSlot.hidden = true
    return
  }
  if (rightPanelPreviewSlot) rightPanelPreviewSlot.hidden = false
}

function showPreviewPanel (previewKey, previewIds, ready) {
  if (!rightPanelPreviewSlot) return

  if (!ready) {
    setRightPanelPreviewLoading(true)
    return
  }

  setRightPanelPreviewLoading(false)

  const alreadyMounted = mountedPreviewTab === previewKey &&
    previewIds.length > 0 &&
    previewIds.every((id) => {
      const el = document.getElementById(id)
      return el && el.parentNode === rightPanelPreviewSlot
    })

  if (alreadyMounted) {
    if (rightPanelPreviewEmpty) rightPanelPreviewEmpty.hidden = true
    if (previewKey === 'button') refreshButtonPreview()
    else if (previewKey === 'branding') renderEmailPreview()
    return
  }

  restoreAllPreviews()

  const previews = previewIds
    .map((id) => document.getElementById(id))
    .filter(Boolean)

  if (!previews.length) {
    mountedPreviewTab = null
    if (rightPanelPreviewEmpty) rightPanelPreviewEmpty.hidden = false
    return
  }

  previews.forEach((el) => {
    rememberPreviewOrigin(el)
    rightPanelPreviewSlot.appendChild(el)
  })
  mountedPreviewTab = previewKey
  if (rightPanelPreviewEmpty) rightPanelPreviewEmpty.hidden = true
  if (previewKey === 'button') refreshButtonPreview()
  else if (previewKey === 'branding') renderEmailPreview()
}

function showButtonPreview () {
  showPreviewPanel('button', BUTTON_PREVIEW_IDS, buttonSectionReady)
}

function showSuccessPreview () {
  showPreviewPanel('success', SUCCESS_PREVIEW_IDS, buttonSectionReady)
  if (buttonSectionReady) loadHostedUnlockSuccessPreview()
}

function showProductCatalogPreview () {
  const unlockPreview = document.getElementById('unlock-preview')
  if (unlockPreview) unlockPreview.hidden = false

  showPreviewPanel(
    'product-catalog',
    PRODUCT_CATALOG_PREVIEW_IDS,
    buttonSectionReady
  )
  if (buttonSectionReady) loadHostedUnlockPreview()
}

function showTrialUsagePreview () {
  showPreviewPanel('feature-usage', ['feature-usage-preview'], buttonSectionReady)
  if (buttonSectionReady) loadHostedFeatureUsagePreview()
}

function showBrandingPreview () {
  showPreviewPanel('branding', BRANDING_PREVIEW_IDS, brandingReady)
}

const hooksStatus = document.getElementById('hooks-status')
const hooksTableWrap = document.getElementById('hooks-table-wrap')
const hooksPagination = document.getElementById('hooks-pagination')
const hooksRangeSelect = document.getElementById('hooks-range')

const hookIdInput = document.getElementById('hook-id-input')
const hookFetchBtn = document.getElementById('hook-fetch-btn')
const hookLookupToggleBtn = document.getElementById('hook-lookup-toggle-btn')
const hookLookupBlock = document.getElementById('hook-lookup-block')
const hookLookupStatus = document.getElementById('hook-lookup-status')
const hookLookupResult = document.getElementById('hook-lookup-result')
const hookLookupRequests = document.getElementById('hook-lookup-requests')
const hookLookupRequestsStatus = document.getElementById('hook-lookup-requests-status')
const hookLookupRequestsTable = document.getElementById('hook-lookup-requests-table')

/** Optional: Chrome Web Store Slowed extension for prefill on *.payhook.link. */
const SLOWED_EXTENSION_ID =
  (typeof window !== 'undefined' && window.SLOWED_EXTENSION_ID) ||
  'gljimdoibfdibckkdmcciihdkbmdjmbc'

const paymentsStatus = document.getElementById('payments-status')
const paymentsTableWrap = document.getElementById('payments-table-wrap')
const paymentsPagination = document.getElementById('payments-pagination')
const paymentsStatusFilter = document.getElementById('payments-status-filter')
const paymentsRangeSelect = document.getElementById('payments-range')
const paymentIdInput = document.getElementById('payment-id-input')
const paymentFetchBtn = document.getElementById('payment-fetch-btn')
const paymentLookupToggleBtn = document.getElementById('payment-lookup-toggle-btn')
const paymentLookupBlock = document.getElementById('payment-lookup-block')
const paymentLookupStatus = document.getElementById('payment-lookup-status')
const paymentLookupResult = document.getElementById('payment-lookup-result')

const brandingStatus = document.getElementById('branding-status')
const brandingForm = document.getElementById('branding-form')
const brandingPrimaryColor = document.getElementById('branding-primary-color')
const brandingPrimaryColorText = document.getElementById('branding-primary-color-text')
const brandingLogoUrl = document.getElementById('branding-logo-url')
const emailDomainAliasInput = document.getElementById('email-domain-alias')
const linkBaseUrlInput = document.getElementById('link-base-url')
const brandingSaveBtn = document.getElementById('branding-save-btn')
const emailPreviewShell = document.getElementById('email-preview-shell')
const emailPreviewHeader = document.getElementById('email-preview-header')

const copyWebsiteSetupBtn = document.getElementById('copy-website-setup-btn')
const copyExtensionSetupBtn = document.getElementById('copy-extension-setup-btn')

const hooksState = { page: 1, range: 'all' }
const paymentsState = { page: 1, range: 'all', status: '' }

// Shared catalog of Stripe products for the active account/mode. Products
// rarely change, so we prefetch the whole list once per dashboard load and
// reuse it for the Unlock Page price picker and the product-sales analytics panel.
const productCatalog = { items: [], loaded: false, promise: null }

const modeToggle = document.getElementById('mode-toggle')
const modeLiveBtn = document.getElementById('mode-live-btn')
const modeTestBtn = document.getElementById('mode-test-btn')

const TEST_MODE_KEY = 'payhook:testMode'

function getTestMode () {
  return window.localStorage.getItem(TEST_MODE_KEY) === 'true'
}

function getTestModeFromUrl () {
  const params = new URLSearchParams(window.location.search)
  if (!params.has('testMode')) return null
  return params.get('testMode') === 'true'
}

function updateModeToggle () {
  const test = getTestMode()
  if (modeLiveBtn) modeLiveBtn.setAttribute('aria-pressed', String(!test))
  if (modeTestBtn) modeTestBtn.setAttribute('aria-pressed', String(test))
}

function setMode (testMode) {
  window.localStorage.setItem(TEST_MODE_KEY, String(testMode))
  setTestModeInUrl(testMode)
  updateModeToggle()
  hooksLoaded = false
  paymentsLoaded = false
  paymentsState.page = 1
  paymentsState.range = 'all'
  paymentsState.status = ''
  hooksState.page = 1
  hooksState.range = 'all'
  settingsLoaded = false
  brandingLoaded = false
  brandingReady = false
  buttonLoaded = false
  buttonSectionReady = false
  apiKeysLoaded = false
  apiConsoleKeysLoaded = false
  experimentsLoaded = false
  loadDashboard()
}

const SECTIONS = ['overview', 'button', 'product-catalog', 'success', 'trial-usage', 'analytics', 'sales', 'experiments', 'hooks', 'payments', 'api-keys', 'api-console', 'branding', 'settings']

// 3650 days (~10y) mirrors the API cap so "Lifetime" is just another days window.
const TIME_RANGES = [
  { value: '7', label: '7d', days: 7, heading: 'last 7 days', short: '7d' },
  { value: '30', label: '30d', days: 30, heading: 'last 30 days', short: '30d' },
  { value: '90', label: '90d', days: 90, heading: 'last 90 days', short: '90d' },
  { value: '365', label: '1y', days: 365, heading: 'last 1 year', short: '1y' },
  { value: 'all', label: 'Lifetime', days: 3650, heading: 'lifetime', short: 'Lifetime' }
]

let analyticsWindow = '7'

function analyticsRange (range = analyticsWindow) {
  return TIME_RANGES.find((r) => r.value === range) || TIME_RANGES[0]
}

const SECTION_PATH_ALIASES = {
  activity: 'analytics',
  requests: 'hooks',
  products: 'product-catalog'
}
const SECTION_URL_SLUG = {
  overview: 'overview',
  button: 'unlock-button',
  success: 'unlock-success',
  'product-catalog': 'unlock-page',
  'trial-usage': 'trial-usage',
  analytics: 'analytics',
  sales: 'sales',
  experiments: 'experiments',
  hooks: 'hooks',
  payments: 'payments',
  'api-keys': 'api-keys',
  'api-console': 'api-console',
  branding: 'branding',
  settings: 'settings'
}
const URL_SLUG_TO_SECTION = Object.fromEntries(
  Object.entries(SECTION_URL_SLUG)
    .filter(([section]) => section !== 'button' && section !== 'success' && section !== 'product-catalog')
    .map(([section, slug]) => [slug, section])
)

function isRequestsAliasPath (pathname = window.location.pathname) {
  const normalized = pathname.replace(/\/$/, '')
  return normalized === '/requests' || normalized.endsWith('/requests')
}

function sectionPath (section, { tab = null } = {}) {
  if (section === 'button') return '/unlock-button/'
  if (section === 'success') return '/unlock-success/'
  if (section === 'product-catalog') {
    const activeTab = tab ?? getActiveCatalogTab()
    if (activeTab && activeTab !== 'catalog') return `/unlock-page/${activeTab}/`
    return '/unlock-page/'
  }
  // Keep /requests/ as a shareable entry for hooks lookup deep-links.
  if (section === 'hooks' && isRequestsAliasPath()) return '/requests/'
  const slug = SECTION_URL_SLUG[section] || section
  return `/${slug}/`
}

function getSectionFromPathname (pathname = window.location.pathname) {
  const segments = pathname.replace(/\/$/, '').split('/').filter(Boolean)
  const first = segments[0]
  if (!first) return null
  const second = segments[1]
  if (
    (first === 'checkout' || first === 'unlock-flow') &&
    (second === 'branding' || second === 'email')
  ) {
    return 'branding'
  }
  // Unlock Success — /unlock-success/ plus legacy /checkout/success/
  if (
    first === 'unlock-success' ||
    ((first === 'checkout' || first === 'unlock-flow') && second === 'success')
  ) {
    return 'success'
  }
  // Trial & Usage — /trial-usage/ plus legacy unlock-page/usage paths
  if (
    first === 'trial-usage' ||
    ((first === 'unlock-page' || first === 'checkout-page' || first === 'product-catalog' || first === 'checkout') &&
      second === 'usage')
  ) {
    return 'trial-usage'
  }
  // Unlock Page — /unlock-page/, tabs, plus legacy checkout/product-catalog paths
  if (
    first === 'unlock-page' ||
    first === 'checkout-page' ||
    first === 'checkout' ||
    first === 'product-catalog'
  ) {
    return 'product-catalog'
  }
  if (first === 'unlock-flow') {
    if (second === 'page') return 'product-catalog'
    return 'button'
  }
  if (
    first === 'unlock-button' ||
    first === 'checkout-button' ||
    first === 'button'
  ) return 'button'
  if (SECTION_PATH_ALIASES[first]) return SECTION_PATH_ALIASES[first]
  if (URL_SLUG_TO_SECTION[first]) return URL_SLUG_TO_SECTION[first]
  return SECTIONS.includes(first) ? first : null
}

function getCatalogTabFromPathname (pathname = window.location.pathname) {
  const segments = pathname.replace(/\/$/, '').split('/').filter(Boolean)
  const first = segments[0]
  const second = segments[1]
  if (
    first === 'unlock-page' ||
    first === 'checkout-page' ||
    first === 'product-catalog'
  ) {
    if (!second) return 'catalog'
    return normalizeCatalogTab(second) || 'catalog'
  }
  if (first === 'checkout' || first === 'unlock-flow') {
    if (!second || second === 'page') return 'catalog'
    if (second === 'success' || second === 'branding' || second === 'email') return null
    return normalizeCatalogTab(second) || 'catalog'
  }
  return null
}

let activeSection = getSectionFromUrl() || 'overview'
let hooksLoaded = false
let paymentsLoaded = false
let productSalesLoaded = false
let featureUsageStatsLoaded = false
let overviewLoaded = false
let overviewLoading = null
let dashboardGeneration = 0
let settingsLoaded = false
let brandingLoaded = false
let brandingReady = false
let buttonLoaded = false
let buttonSectionReady = false
let apiKeysLoaded = false
let apiConsoleKeysLoaded = false
let experimentsLoaded = false
let emailAccountName = ''
let currentUser = null
let currentAccount = null
let pendingAuthEmail = ''
let workspaces = []
let currentWorkspaceId = null

function getStoredWorkspaceId () {
  try { return window.localStorage.getItem(WORKSPACE_ID_KEY) } catch { return null }
}

function setStoredWorkspaceId (id) {
  try {
    if (id) window.localStorage.setItem(WORKSPACE_ID_KEY, id)
    else window.localStorage.removeItem(WORKSPACE_ID_KEY)
  } catch {}
}

function getActiveWorkspace () {
  return workspaces.find((w) => w.workspaceId === currentWorkspaceId) || null
}

function getCatalogTabFromUrl () {
  const fromPath = getCatalogTabFromPathname()
  if (fromPath && PRODUCT_CATALOG_TABS.includes(fromPath)) return fromPath
  return null
}

function getSectionFromUrl () {
  return getSectionFromPathname()
}

function getHistoryState () {
  const state = { section: activeSection, testMode: getTestMode() }
  if (activeSection === 'product-catalog') state.tab = getActiveCatalogTab()
  return state
}

function setTestModeInUrl (testMode, { replace = false } = {}) {
  const url = new URL(window.location.href)
  if (testMode) {
    url.searchParams.set('testMode', 'true')
  } else {
    url.searchParams.delete('testMode')
  }
  const state = getHistoryState()
  if (replace) {
    window.history.replaceState(state, '', url.toString())
  } else {
    window.history.pushState(state, '', url.toString())
  }
}

function syncTestModeFromUrl () {
  const fromUrl = getTestModeFromUrl()
  if (fromUrl !== null) {
    window.localStorage.setItem(TEST_MODE_KEY, String(fromUrl))
    return
  }
  if (getTestMode()) {
    setTestModeInUrl(true, { replace: true })
  }
}

function applyTestMode (testMode) {
  if (testMode === getTestMode()) return
  window.localStorage.setItem(TEST_MODE_KEY, String(testMode))
  updateModeToggle()
  hooksLoaded = false
  paymentsLoaded = false
  paymentsState.page = 1
  paymentsState.range = 'all'
  paymentsState.status = ''
  hooksState.page = 1
  hooksState.range = 'all'
  settingsLoaded = false
  brandingLoaded = false
  brandingReady = false
  buttonLoaded = false
  buttonSectionReady = false
  apiKeysLoaded = false
  apiConsoleKeysLoaded = false
  experimentsLoaded = false
  loadDashboard()
}

function buildSectionUrl (section, { tab } = {}) {
  const pathTab = section === 'product-catalog'
    ? (tab ?? getActiveCatalogTab())
    : null
  const path = sectionPath(section, { tab: pathTab })
  const url = new URL(path, window.location.origin)
  const current = new URL(window.location.href)
  url.search = current.search
  url.hash = current.hash
  url.searchParams.delete('section')
  url.searchParams.delete('tab')
  if (section !== 'hooks' && section !== 'api-console') {
    url.searchParams.delete('paymentHookId')
    url.searchParams.delete('hookId')
    url.searchParams.delete('hours')
  }
  if (section !== 'api-console') {
    url.searchParams.delete('endpoint')
    url.searchParams.delete('paymentId')
    url.searchParams.delete('productId')
    url.searchParams.delete('priceId')
    url.searchParams.delete('email')
  }
  return url
}

function setSectionInUrl (section, { replace = false } = {}) {
  const url = buildSectionUrl(section)
  const state = getHistoryState()
  if (replace) {
    window.history.replaceState(state, '', url.toString())
  } else {
    window.history.pushState(state, '', url.toString())
  }
}

function setCatalogTabInUrl (tab) {
  const url = buildSectionUrl('product-catalog', { tab })
  window.history.pushState(getHistoryState(), '', url.toString())
}

function navigateTo (section, { updateUrl = true, replace = false } = {}) {
  activeSection = section
  if (updateUrl) setSectionInUrl(section, { replace })

  SECTIONS.forEach(s => {
    const el = document.getElementById(`section-${s}`)
    if (el) el.hidden = s !== section
  })

  document.querySelectorAll('.dash-sidebar__item').forEach(btn => {
    btn.classList.toggle('is-active', btn.dataset.section === section)
  })

  if ((section === 'overview' || section === 'analytics') && !overviewLoaded) {
    loadDashboardOverview()
  }

  if (section === 'analytics') {
    loadFeatureUsageStats()
  }

  if (section === 'sales') {
    loadProductSales()
  }

  if (section === 'hooks' && !hooksLoaded) {
    hooksLoaded = true
    syncListRangeSelects()
    if (!isEmbedMode()) loadPaymentHooks()
    void maybeOpenHookLookupFromUrl()
  } else if (section === 'hooks') {
    void maybeOpenHookLookupFromUrl()
  }

  if (section === 'payments' && !paymentsLoaded) {
    paymentsLoaded = true
    syncListRangeSelects()
    setFilterSwitchPressed(paymentsStatusFilter, 'data-status', paymentsState.status || '')
    loadPayments()
  }

  if (section === 'api-keys' && !apiKeysLoaded) {
    apiKeysLoaded = true
    loadApiKeys()
  }

  if (section === 'experiments' && !experimentsLoaded) {
    experimentsLoaded = true
    // Keep navigateTo sync — a throw here would leave the dashboard shell
    // half-mounted (sidebar visible, content never shown).
    void loadExperiments().catch((error) => {
      experimentsLoaded = false
      setExperimentsStatus('error', error.message || 'Failed to load experiments.')
    })
  }

  if (section === 'api-console') {
    void prepareApiConsole()
  }

  if (section === 'settings') {
    if (!settingsLoaded) {
      settingsLoaded = true
      loadSettings()
    }
    restoreAllPreviews()
    setRightPanelMode('setup')
  } else if (section === 'branding') {
    setRightPanelMode('preview')
    if (!brandingLoaded) {
      brandingLoaded = true
      loadBrandingSection()
    } else {
      showBrandingPreview()
    }
  } else if (section === 'button' || section === 'product-catalog' || section === 'success' || section === 'trial-usage') {
    setRightPanelMode('preview')
    if (!buttonLoaded) {
      buttonLoaded = true
      loadButtonSection()
    } else if (section === 'button') {
      showButtonContent()
      showButtonPreview()
    } else if (section === 'success') {
      showSuccessContent()
      showSuccessPreview()
    } else if (section === 'trial-usage') {
      showTrialUsageContent()
      showTrialUsagePreview()
    } else {
      showProductCatalogContent()
      showProductCatalogPreview()
    }
  } else {
    restoreAllPreviews()
    setRightPanelMode('setup')
  }
}

function getRedirectUri () {
  return 'https://dashboard.payhook.link'
}

function buildConnectUrl () {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: STRIPE_CLIENT_ID,
    scope: 'read_write',
    redirect_uri: getRedirectUri()
  })

  return `https://connect.stripe.com/oauth/v2/authorize?${params.toString()}`
}

function redirectToStripeConnect () {
  window.location.assign(buildConnectUrl())
}

function getOAuthCodeFromUrl () {
  const params = new URLSearchParams(window.location.search)
  return params.get('code')
}

function stripOAuthParamsFromUrl () {
  const url = new URL(window.location.href)
  url.searchParams.delete('code')
  url.searchParams.delete('scope')
  url.searchParams.delete('state')
  url.searchParams.delete('account')
  window.history.replaceState(getHistoryState(), '', url.toString())
}

function getAuthErrorFromUrl () {
  const params = new URLSearchParams(window.location.search)
  const value = params.get('authError')
  if (!value) return ''
  return decodeURIComponent(value)
}

function stripAuthErrorFromUrl () {
  const url = new URL(window.location.href)
  if (!url.searchParams.has('authError')) return
  url.searchParams.delete('authError')
  window.history.replaceState(getHistoryState(), '', url.toString())
}

function formatStatValue (value) {
  if (value === null || value === undefined || value === '') return '—'
  const text = String(value)
  const moreMatch = text.match(/^(.+?)(\+)$/)
  if (moreMatch) {
    return `<span class="stat-card__value-main">${escapeHtml(moreMatch[1])}</span><span class="stat-card__value-suffix" title="More than shown">+</span>`
  }
  return `<span class="stat-card__value-main">${escapeHtml(text)}</span>`
}

function renderStatCard (label, value) {
  const card = document.createElement('article')
  card.className = 'stat-card'
  card.innerHTML = `<p class="stat-card__label">${escapeHtml(label)}</p><p class="stat-card__value">${formatStatValue(value)}</p>`
  return card
}

const ACTIVITY_CHART_SERIES = [
  { key: 'paymentHooks', modifier: 'hooks', singular: 'hook' },
  { key: 'payments', modifier: 'payments', singular: 'payment' },
  { key: 'unlockClicks', modifier: 'unlock', singular: 'unlock click' }
]

function syncAnalyticsRangeCopy (range = analyticsRange()) {
  if (activityPanelCopy) {
    activityPanelCopy.textContent =
      `Hooks, payments, and unlock button clicks per day (${range.heading}, UTC). Country is inferred from the visitor IP via CloudFront.`
  }
  if (activityCountriesCopy) {
    activityCountriesCopy.textContent =
      `Top countries for unlock button clicks (${range.heading}).`
  }
  if (productSalesCopy) {
    productSalesCopy.textContent =
      `Confirmed payments per product and each product's share of total sales (${range.heading}).`
  }
  if (priceSalesCopy) {
    priceSalesCopy.textContent =
      `Which Stripe prices customers chose, with each price's share of total sales (${range.heading}).`
  }
  if (featureUsageStatsCopy) {
    featureUsageStatsCopy.textContent =
      `Per-user used credits (p50 / p90 / p99) and totals (${range.heading}). Use percentiles to set weekly/monthly caps.`
  }
  if (featureUsageChartCopy) {
    featureUsageChartCopy.textContent =
      `Used credits and cap hits per day (${range.heading}, UTC).`
  }
  if (featureUsageCountriesCopy) {
    featureUsageCountriesCopy.textContent =
      `Top countries for feature usage (${range.heading}).`
  }
  if (overviewRangeSelect) overviewRangeSelect.value = range.value
  if (analyticsRangeSelect) analyticsRangeSelect.value = range.value
  if (salesRangeSelect) salesRangeSelect.value = range.value
}

function renderActivityChart (activity) {
  if (!activityPanel || !activityChart) return

  activityPanel.hidden = false
  activityChart.replaceChildren()

  const range = analyticsRange()

  paintActivityChart(activityChart, activity && activity.days ? activity.days : [], {
    series: ACTIVITY_CHART_SERIES,
    emptyText: 'No analytics data.',
    width: 640,
    ariaLabel: (totals) =>
      `Daily analytics for the ${range.heading}. ${totals.paymentHooks} hooks, ` +
      `${totals.payments} payments, ${totals.unlockClicks} unlock clicks total.`
  })
}

function formatCountryLabel (countryCode) {
  if (!countryCode || countryCode === 'XX') return 'Unknown'
  try {
    return new Intl.DisplayNames(undefined, { type: 'region' }).of(countryCode) || countryCode
  } catch {
    return countryCode
  }
}

function renderUnlockCountries (tracking) {
  if (!activityCountriesPanel || !activityCountriesList) return

  const unlockStats = tracking && tracking.unlock_click
  const countries = unlockStats && unlockStats.topCountries ? unlockStats.topCountries : []

  if (!countries.length) {
    activityCountriesPanel.hidden = true
    activityCountriesList.replaceChildren()
    return
  }

  activityCountriesPanel.hidden = false
  activityCountriesList.replaceChildren()

  countries.slice(0, 10).forEach(({ country, count }) => {
    const row = document.createElement('tr')
    row.innerHTML = `
      <td>${escapeHtml(formatCountryLabel(country))} <span class="country-code">(${escapeHtml(country)})</span></td>
      <td>${escapeHtml(count)}</td>
    `
    activityCountriesList.appendChild(row)
  })
}

const FEATURE_USAGE_CHART_SERIES = [
  { key: 'used', modifier: 'usage-used', singular: 'credit used', plural: 'credits used' },
  { key: 'hit', modifier: 'usage-hit', singular: 'cap hit' }
]

function formatFeatureLimits (limits) {
  if (!limits || typeof limits !== 'object') return ''
  const parts = []
  if (limits.weekly != null) parts.push(`${limits.weekly}/wk`)
  if (limits.monthly != null) parts.push(`${limits.monthly}/mo`)
  return parts.join(' · ')
}

function formatUsageStat (value) {
  if (value == null || Number.isNaN(Number(value))) return '—'
  return String(value)
}

function renderFeatureUsageStats (data) {
  if (!featureUsageStatsPanel || !featureUsageStatsList) return

  const features = (data && data.features) ? data.features : []
  const hasAny = features.some((feature) =>
    feature.used > 0 || feature.trial > 0 || feature.entitled > 0 || feature.hit > 0 ||
    feature.subjects > 0
  )

  if (!features.length) {
    featureUsageStatsPanel.hidden = false
    featureUsageStatsList.replaceChildren()
    if (featureUsageChartPanel) featureUsageChartPanel.hidden = true
    if (featureUsageCountriesPanel) featureUsageCountriesPanel.hidden = true
    if (featureUsageStatsStatus) {
      featureUsageStatsStatus.hidden = false
      featureUsageStatsStatus.textContent = data && data.enabled === false
        ? 'Feature usage metering is off. Enable it under Trial & Usage to start collecting analytics.'
        : 'No features configured for usage metering yet.'
      featureUsageStatsStatus.className = 'dashboard-status dashboard-status--empty'
    }
    return
  }

  if (featureUsageStatsStatus) featureUsageStatsStatus.hidden = true
  featureUsageStatsPanel.hidden = false
  featureUsageStatsList.replaceChildren()

  features.forEach((feature) => {
    const limits = formatFeatureLimits(feature.limits)
    const row = document.createElement('tr')
    row.innerHTML = `
      <td>${escapeHtml(feature.feature)}${limits ? ` <span class="country-code">(${escapeHtml(limits)})</span>` : ''}</td>
      <td>${formatUsageStat(feature.subjects)}</td>
      <td>${formatUsageStat(feature.p50)}</td>
      <td>${formatUsageStat(feature.p90)}</td>
      <td>${formatUsageStat(feature.p99)}</td>
      <td>${feature.used || 0}</td>
      <td>${feature.trial || 0}</td>
      <td>${feature.entitled || 0}</td>
      <td>${feature.hit || 0}</td>
    `
    featureUsageStatsList.appendChild(row)
  })

  if (featureUsageChartPanel && featureUsageChart) {
    const days = (data && data.daysSeries) ? data.daysSeries : []
    if (!hasAny && !days.some((day) => day.used > 0 || day.hit > 0)) {
      featureUsageChartPanel.hidden = true
      featureUsageChart.replaceChildren()
    } else {
      featureUsageChartPanel.hidden = false
      const range = analyticsRange()
      paintActivityChart(featureUsageChart, days, {
        series: FEATURE_USAGE_CHART_SERIES,
        emptyText: 'No feature usage yet.',
        width: 640,
        ariaLabel: (totals) =>
          `Daily feature usage for the ${range.heading}. ${totals.used} credits used, ` +
          `${totals.hit} cap hits total.`
      })
    }
  }

  if (featureUsageCountriesPanel && featureUsageCountriesList) {
    const countries = (data && data.topCountries) ? data.topCountries : []
    if (!countries.length) {
      featureUsageCountriesPanel.hidden = true
      featureUsageCountriesList.replaceChildren()
    } else {
      featureUsageCountriesPanel.hidden = false
      featureUsageCountriesList.replaceChildren()
      countries.slice(0, 10).forEach(({ country, count }) => {
        const row = document.createElement('tr')
        row.innerHTML = `
          <td>${escapeHtml(formatCountryLabel(country))} <span class="country-code">(${escapeHtml(country)})</span></td>
          <td>${escapeHtml(count)}</td>
        `
        featureUsageCountriesList.appendChild(row)
      })
    }
  }
}

async function loadFeatureUsageStats ({ force = false } = {}) {
  if (!featureUsageStatsPanel && !featureUsageStatsStatus) return
  if (!force && featureUsageStatsLoaded) return
  featureUsageStatsLoaded = true

  if (featureUsageStatsStatus) {
    featureUsageStatsStatus.hidden = false
    featureUsageStatsStatus.textContent = 'Loading…'
    featureUsageStatsStatus.className = 'dashboard-status dashboard-status--loading'
  }
  if (featureUsageStatsPanel) featureUsageStatsPanel.hidden = true
  if (featureUsageChartPanel) featureUsageChartPanel.hidden = true
  if (featureUsageCountriesPanel) featureUsageCountriesPanel.hidden = true

  try {
    const range = analyticsRange()
    syncAnalyticsRangeCopy(range)
    const data = await apiRequest(`/dashboard/feature_usage/stats?days=${range.days}`)
    renderFeatureUsageStats(data)
  } catch (error) {
    featureUsageStatsLoaded = false
    if (featureUsageStatsPanel) featureUsageStatsPanel.hidden = true
    if (featureUsageChartPanel) featureUsageChartPanel.hidden = true
    if (featureUsageCountriesPanel) featureUsageCountriesPanel.hidden = true
    if (featureUsageStatsStatus) {
      featureUsageStatsStatus.hidden = false
      featureUsageStatsStatus.textContent = error.message || 'Failed to load feature usage analytics.'
      featureUsageStatsStatus.className = 'dashboard-status dashboard-status--error'
    }
  }
}

function renderShareCell (share) {
  return `
    <div class="market-share">
      <span class="market-share__bar"><span class="market-share__fill" style="width: ${(share * 100).toFixed(1)}%"></span></span>
      <span class="market-share__value">${formatSharePercent(share)}</span>
    </div>
  `
}

function resolveSalesProductName (productId, namedProducts) {
  const named = (namedProducts || []).find((p) => p.productId === productId)
  if (named && named.name) return named.name
  const catalog = productCatalog.items.find((p) => p.id === productId)
  return (catalog && catalog.name) || productId
}

function resolveSalesPriceLabel (priceId) {
  const match = findCatalogPrice(priceId)
  if (match) return formatCatalogPriceLabel(match.price)
  return priceId
}

function renderProductSales (data) {
  if (!productSalesPanel || !productSalesList) return

  const products = (data && data.products) ? data.products : []
  const prices = (data && data.prices) ? data.prices : []
  const hasSales = products.length > 0 || prices.length > 0

  if (!hasSales) {
    productSalesPanel.hidden = false
    if (priceSalesPanel) priceSalesPanel.hidden = true
    productSalesList.replaceChildren()
    if (priceSalesList) priceSalesList.replaceChildren()
    if (productSalesStatus) {
      productSalesStatus.hidden = false
      productSalesStatus.textContent = 'No sales yet.'
      productSalesStatus.className = 'dashboard-status dashboard-status--empty'
    }
    return
  }

  if (productSalesStatus) productSalesStatus.hidden = true
  productSalesPanel.hidden = false
  productSalesList.replaceChildren()

  products.forEach(({ name, productId, count, share }) => {
    const row = document.createElement('tr')
    row.innerHTML = `
      <td>${escapeHtml(name || productId)} <span class="country-code">(${escapeHtml(productId)})</span></td>
      <td>${count}</td>
      <td>${renderShareCell(share)}</td>
    `
    productSalesList.appendChild(row)
  })

  if (!priceSalesPanel || !priceSalesList) return
  priceSalesPanel.hidden = false
  priceSalesList.replaceChildren()

  if (!prices.length) {
    const empty = document.createElement('tr')
    empty.innerHTML = '<td colspan="4">No price breakdown for this range.</td>'
    priceSalesList.appendChild(empty)
    return
  }

  prices.forEach(({ productId, priceId, count, share }) => {
    const productName = resolveSalesProductName(productId, products)
    const priceLabel = resolveSalesPriceLabel(priceId)
    const row = document.createElement('tr')
    row.innerHTML = `
      <td>${escapeHtml(productName)} <span class="country-code">(${escapeHtml(productId)})</span></td>
      <td>${escapeHtml(priceLabel)} <span class="country-code">(${escapeHtml(priceId)})</span></td>
      <td>${count}</td>
      <td>${renderShareCell(share)}</td>
    `
    priceSalesList.appendChild(row)
  })
}

async function loadProductSales ({ force = false } = {}) {
  if (!productSalesPanel && !productSalesStatus) return
  if (!force && productSalesLoaded) return
  productSalesLoaded = true

  if (productSalesStatus) {
    productSalesStatus.hidden = false
    productSalesStatus.textContent = 'Loading…'
    productSalesStatus.className = 'dashboard-status dashboard-status--loading'
  }
  if (productSalesPanel) productSalesPanel.hidden = true
  if (priceSalesPanel) priceSalesPanel.hidden = true

  try {
    const range = analyticsRange()
    syncAnalyticsRangeCopy(range)
    const [data] = await Promise.all([
      apiRequest(`/dashboard/product_sales?days=${range.days}`),
      loadProductCatalog().catch((error) => {
        console.warn('Failed to load product catalog for sales labels', error)
        return []
      })
    ])
    renderProductSales(data)
  } catch (error) {
    productSalesLoaded = false
    if (productSalesPanel) productSalesPanel.hidden = true
    if (priceSalesPanel) priceSalesPanel.hidden = true
    if (productSalesStatus) {
      productSalesStatus.hidden = false
      productSalesStatus.textContent = error.message || 'Failed to load product sales.'
      productSalesStatus.className = 'dashboard-status dashboard-status--error'
    }
  }
}

function formatMoney (amount, currency) {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: (currency || 'usd').toUpperCase()
  }).format(amount / 100)
}

function setStatus (message, type = 'loading', target = dashboardStatus) {
  if (!target) return
  target.hidden = !message
  target.textContent = message || ''
  target.className = `dashboard-status dashboard-status--${type}`
}

function initActionButton (button) {
  if (button && !button.dataset.defaultLabel) {
    button.dataset.defaultLabel = button.textContent.trim()
  }
}

function setActionButtonState (button, state, { loadingLabel, successLabel } = {}) {
  if (!button) return
  initActionButton(button)
  const defaultLabel = button.dataset.defaultLabel
  button.classList.remove('is-loading', 'is-success')

  if (state === 'loading') {
    button.classList.add('is-loading')
    button.disabled = true
    button.textContent = loadingLabel || 'Loading…'
    return
  }

  if (state === 'success') {
    button.classList.add('is-success')
    button.disabled = false
    button.textContent = successLabel || 'Saved'
    window.setTimeout(() => {
      if (button.classList.contains('is-success')) setActionButtonState(button, 'idle')
    }, 1800)
    return
  }

  button.disabled = false
  button.textContent = defaultLabel
}

function setFormSaveState (button, statusEl, state, message = '') {
  if (state === 'loading') {
    setActionButtonState(button, 'loading', { loadingLabel: 'Saving…' })
    if (statusEl) setStatus('', 'idle', statusEl)
    return
  }

  if (state === 'success') {
    setActionButtonState(button, 'success', { successLabel: 'Saved' })
    if (statusEl) setStatus('', 'idle', statusEl)
    return
  }

  if (state === 'error') {
    setActionButtonState(button, 'error')
    if (statusEl) setStatus(message, 'error', statusEl)
    return
  }

  setActionButtonState(button, 'idle')
  if (statusEl) setStatus('', 'idle', statusEl)
}

function hideAllDashSections () {
  SECTIONS.forEach((section) => {
    const el = document.getElementById(`section-${section}`)
    if (el) el.hidden = true
  })
}

function showDashboardLoading (message = 'Loading dashboard…') {
  hideAllDashSections()
  if (dashSidebar) dashSidebar.hidden = true
  if (dashLayout) dashLayout.hidden = true
  if (bootLoading) {
    bootLoading.hidden = false
    if (bootLoadingText) bootLoadingText.textContent = message
  }
  if (dashboardLoading) {
    dashboardLoading.hidden = true
    dashboardLoading.classList.remove('dashboard-loading--error')
  }
  if (dashboardLoadingRetry) dashboardLoadingRetry.hidden = true
  setStatus('')
}

function showDashboardContent () {
  hideBootLoading()
  if (dashboardLoading) {
    dashboardLoading.hidden = true
    dashboardLoading.classList.remove('dashboard-loading--error')
  }
  if (dashboardLoadingRetry) dashboardLoadingRetry.hidden = true
  if (dashLayout) dashLayout.hidden = false
  setStatus('')
}

function setConnectStatus (message, type = 'error') {
  setStatus(message, type, connectStatus)
}

function setConnectAction (href, label) {
  connectStripeBtn.href = href
  connectStripeBtn.textContent = label

  if (headerConnectBtn) {
    headerConnectBtn.href = href
    headerConnectBtn.textContent = label
  }
}

function rememberAuthEmail (email) {
  if (email) window.localStorage.setItem(SESSION_EMAIL_KEY, email)
}

function getStoredAuthEmail () {
  return window.localStorage.getItem(SESSION_EMAIL_KEY)
}

function clearStoredAuthEmail () {
  window.localStorage.removeItem(SESSION_EMAIL_KEY)
}

function setAuthBusy (busy) {
  if (busy) {
    setActionButtonState(authSubmitBtn, 'loading', { loadingLabel: 'Sending…' })
    if (authResendBtn) authResendBtn.disabled = true
  } else {
    setActionButtonState(authSubmitBtn, 'idle')
    if (authResendBtn) authResendBtn.disabled = false
  }
}

function showAuthFormPanel () {
  if (storageAccessPanel) storageAccessPanel.hidden = true
  if (authPanelLead) authPanelLead.hidden = false
  if (authFormPanel) authFormPanel.hidden = false
  if (authSentPanel) authSentPanel.hidden = true
  setAuthBusy(false)
  if (authEmailInput) authEmailInput.focus()
}

// When embedded in a third-party iframe (e.g. console.slowed.app's requests
// view), browsers that block third-party cookies outright (Safari ITP,
// Firefox ETP) never send the session cookie even though the API now issues
// it as SameSite=None. The Storage Access API is the standard escape hatch:
// it must be invoked from a user gesture, so we show a button rather than
// calling it automatically.
function isEmbedded () {
  try {
    return window.top !== window.self
  } catch (error) {
    return true
  }
}

function supportsStorageAccess () {
  return typeof document.hasStorageAccess === 'function' && typeof document.requestStorageAccess === 'function'
}

async function needsStorageAccess () {
  if (!isEmbedded() || !supportsStorageAccess()) return false
  try {
    return !(await document.hasStorageAccess())
  } catch (error) {
    return false
  }
}

function showStorageAccessPanel () {
  hideBootLoading()
  connectView.hidden = false
  dashboardView.hidden = true
  if (workspacePickerView) workspacePickerView.hidden = true
  connectTitle.textContent = 'Sign in to Payhook'
  connectLead.textContent = 'Your dashboard is protected by your Payhook account.'
  if (stripeConnectPanel) stripeConnectPanel.hidden = true
  if (authPanel) authPanel.hidden = false
  if (storageAccessPanel) storageAccessPanel.hidden = false
  if (authPanelLead) authPanelLead.hidden = true
  if (authFormPanel) authFormPanel.hidden = true
  if (authSentPanel) authSentPanel.hidden = true
  if (headerConnectBtn) headerConnectBtn.hidden = true
  if (modeToggle) modeToggle.hidden = true
  if (workspaceSwitcher) workspaceSwitcher.hidden = true
  if (appRail) appRail.hidden = true
  setConnectStatus('')
  setStatus('', 'loading', storageAccessStatus)
  if (storageAccessBtn) storageAccessBtn.disabled = false
}

if (storageAccessBtn) {
  storageAccessBtn.addEventListener('click', async () => {
    storageAccessBtn.disabled = true
    setStatus('Requesting access…', 'loading', storageAccessStatus)
    try {
      await document.requestStorageAccess()
      setStatus('', 'loading', storageAccessStatus)
      await bootstrap()
    } catch (error) {
      setStatus('Your browser blocked access. Sign in with your email below instead.', 'error', storageAccessStatus)
      showAuthFormPanel()
    }
  })
}

function showAuthSentPanel ({ email }) {
  if (authFormPanel) authFormPanel.hidden = true
  if (authSentPanel) authSentPanel.hidden = false
  if (authSentLead) {
    authSentLead.textContent = `We sent a sign-in link to ${email}. Open it on this device to continue. The link expires in 15 minutes.`
  }
  setAuthBusy(false)
}

function resetAuthForm () {
  pendingAuthEmail = ''
  if (authEmailInput) authEmailInput.value = getStoredAuthEmail() || ''
  showAuthFormPanel()
}

async function authRequest (path, body) {
  return apiRequest(path, {
    method: 'POST',
    body: JSON.stringify(body || {}),
    live: true,
    retryAuth: false
  })
}

async function requestMagicLink (email) {
  await authRequest('/auth/magic-link', { email })
  rememberAuthEmail(email)
  pendingAuthEmail = email
  showAuthSentPanel({ email })
  setConnectStatus('')
}

function showAuthView ({ message = '' } = {}) {
  hideBootLoading()
  closeWorkspaceMenu()
  connectView.hidden = false
  dashboardView.hidden = true
  if (workspacePickerView) workspacePickerView.hidden = true
  connectTitle.textContent = 'Sign in to Payhook'
  connectLead.textContent = 'Your dashboard is protected by your Payhook account.'
  if (authPanelLead) {
    authPanelLead.textContent = 'Enter your email and we will send you a sign-in link to open the dashboard.'
  }
  if (authPanel) authPanel.hidden = false
  if (stripeConnectPanel) stripeConnectPanel.hidden = true
  resetAuthForm()
  if (headerConnectBtn) headerConnectBtn.hidden = true
  if (modeToggle) modeToggle.hidden = true
  if (workspaceSwitcher) workspaceSwitcher.hidden = true
  if (appRail) appRail.hidden = true
  setConnectStatus(message)
}

function showConnectView ({ message = '', autoRedirect = false } = {}) {
  hideBootLoading()
  connectView.hidden = false
  dashboardView.hidden = true
  if (workspacePickerView) workspacePickerView.hidden = true
  connectTitle.textContent = 'Connect Stripe'
  connectLead.textContent = 'Finish setup by connecting the Stripe account Payhook should manage.'
  if (connectPanelLead) {
    connectPanelLead.textContent = 'Payhook uses Stripe Connect after you sign in, then associates that Stripe account with your Payhook account.'
  }
  if (authPanel) authPanel.hidden = true
  if (stripeConnectPanel) stripeConnectPanel.hidden = false
  setConnectAction(buildConnectUrl(), 'Connect Stripe')
  updateSiteHeader()
  // Keep the rail + workspace switcher available so users can switch to a
  // connected workspace or create one without leaving the connect screen.
  setAppRailVisible(true)
  renderWorkspaceSwitcher()

  if (autoRedirect) {
    setConnectStatus('Redirecting to Stripe…', 'loading')
    redirectToStripeConnect()
    return
  }

  setConnectStatus(message)
}

function showDashboardView () {
  connectView.hidden = true
  dashboardView.hidden = false
  if (workspacePickerView) workspacePickerView.hidden = true
  setAppRailVisible(true)
  updateSiteHeader()
  renderWorkspaceSwitcher()
}

function showWorkspacePicker () {
  hideBootLoading()
  closeWorkspaceMenu()
  connectView.hidden = true
  dashboardView.hidden = true
  if (workspacePickerView) workspacePickerView.hidden = false
  setAppRailVisible(true)
  if (modeToggle) modeToggle.hidden = true
  if (headerConnectBtn) headerConnectBtn.hidden = true
  updateSiteHeader()
  renderWorkspaceSwitcher()
  renderWorkspacePicker()
}

async function apiRequest (path, options = {}) {
  const { live = false, headers: optionHeaders, retryAuth = true, ...fetchOptions } = options
  const headers = {
    ...(fetchOptions.body !== undefined ? { 'Content-Type': 'application/json' } : {}),
    ...(getTestMode() && !live ? { 'Test-Mode': 'true' } : {}),
    ...(currentWorkspaceId ? { 'X-Payhook-Workspace': currentWorkspaceId } : {}),
    ...(optionHeaders || {})
  }

  const response = await window.fetch(`${API_URL}${path}`, {
    ...fetchOptions,
    credentials: 'include',
    headers
  })

  const body = await response.json().catch(() => ({}))
  if (!response.ok) {
    if (retryAuth && (response.status === 401 || response.status === 410) && path !== '/auth/refresh') {
      await apiRequest('/auth/refresh', {
        method: 'POST',
        body: JSON.stringify({}),
        live: true,
        retryAuth: false
      })
      return apiRequest(path, { ...options, retryAuth: false })
    }

    const message = body.error && (body.error.message || body.error)
    const error = new Error(typeof message === 'string' ? message : `Request failed (${response.status})`)
    error.status = response.status
    throw error
  }

  return body
}

function applyBootstrap (data) {
  currentUser = data.user || null
  workspaces = Array.isArray(data.workspaces) ? data.workspaces : []

  // Use the stored selection only if it is still valid. There is no default
  // workspace — when nothing is selected the user must pick one explicitly.
  const stored = getStoredWorkspaceId()
  const active = workspaces.find((w) => w.workspaceId === stored) || null
  currentWorkspaceId = active ? active.workspaceId : null
  setStoredWorkspaceId(currentWorkspaceId)

  syncAccountFromWorkspace(active)
  updateSiteHeader()
  renderWorkspaceSwitcher()
  prefetchWorkspaceExtensionLogos()
  return data
}

async function loadBootstrap () {
  const data = await apiRequest('/dashboard/bootstrap', { live: true })
  return applyBootstrap(data)
}

// The active workspace's Stripe account drives dashboard gating. A workspace
// without Stripe connected falls back to the "connect Stripe" view.
function syncAccountFromWorkspace (workspace) {
  if (workspace && workspace.stripeAccountId) {
    currentAccount = { accountId: workspace.stripeAccountId }
    setStoredAccountId(workspace.stripeAccountId)
  } else {
    currentAccount = null
    clearStoredAccountId()
  }
}

function workspaceInitial (workspace) {
  const name = ((workspace && workspace.name) || '').trim()
  return name ? name.charAt(0).toUpperCase() : '?'
}

function workspaceStripeLabel (workspace) {
  return workspace && workspace.stripeAccountId ? 'Stripe connected' : 'Stripe not connected'
}

/** Chrome extension ids are 32 lowercase letters a–p. */
const VALID_EXTENSION_ID = /^[a-p]{32}$/
const extensionLogoCache = new Map()

function isValidExtensionId (value) {
  return typeof value === 'string' && VALID_EXTENSION_ID.test(value)
}

function encodeProtobufVarint (n) {
  const out = []
  let value = n >>> 0
  while (value >= 0x80) {
    out.push((value & 0x7f) | 0x80)
    value >>>= 7
  }
  out.push(value)
  return out
}

function encodeProtobufStringField (fieldNum, text) {
  const data = new TextEncoder().encode(text)
  return Uint8Array.from([
    (fieldNum << 3) | 2,
    ...encodeProtobufVarint(data.length),
    ...data
  ])
}

function decodeProtobufVarint (buf, offset) {
  let result = 0
  let shift = 0
  let i = offset
  while (i < buf.length) {
    const byte = buf[i++]
    result |= (byte & 0x7f) << shift
    if ((byte & 0x80) === 0) return { value: result, offset: i }
    shift += 7
  }
  throw new Error('Truncated protobuf varint')
}

/** Parse length-delimited string fields from a flat protobuf message. */
function parseProtobufStringFields (buf) {
  const fields = new Map()
  let i = 0
  while (i < buf.length) {
    const key = decodeProtobufVarint(buf, i)
    i = key.offset
    const fieldNum = key.value >>> 3
    const wireType = key.value & 7
    if (wireType === 0) {
      i = decodeProtobufVarint(buf, i).offset
    } else if (wireType === 1) {
      i += 8
    } else if (wireType === 5) {
      i += 4
    } else if (wireType === 2) {
      const len = decodeProtobufVarint(buf, i)
      i = len.offset
      const slice = buf.subarray(i, i + len.value)
      i += len.value
      const list = fields.get(fieldNum) || []
      list.push(new TextDecoder().decode(slice))
      fields.set(fieldNum, list)
    } else {
      throw new Error(`Unsupported protobuf wire type ${wireType}`)
    }
  }
  return fields
}

function sizedChromeWebStoreLogoUrl (logoUri) {
  if (!logoUri || typeof logoUri !== 'string') return null
  if (logoUri.includes('=')) return logoUri
  return `${logoUri}=s128`
}

async function fetchChromeWebStoreLogoUrl (extensionId) {
  const body = encodeProtobufStringField(1, extensionId)
  const response = await fetch(
    `https://chromewebstore.googleapis.com/v2/items/${encodeURIComponent(extensionId)}:fetchItemSnippet`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-protobuf',
        'X-HTTP-Method-Override': 'GET'
      },
      body,
      credentials: 'omit'
    }
  )
  if (!response.ok) {
    throw new Error(`Chrome Web Store lookup failed (${response.status})`)
  }
  const buf = new Uint8Array(await response.arrayBuffer())
  // FetchItemSnippetResponse.logo_uri = field 5
  const logoUri = (parseProtobufStringFields(buf).get(5) || [])[0]
  const url = sizedChromeWebStoreLogoUrl(logoUri)
  if (!url) throw new Error('Chrome Web Store item has no logo')
  return url
}

function getCachedExtensionLogo (extensionId) {
  if (!isValidExtensionId(extensionId)) return null
  const entry = extensionLogoCache.get(extensionId)
  return entry && entry.status === 'ready' ? entry.url : null
}

function ensureExtensionLogo (extensionId) {
  if (!isValidExtensionId(extensionId)) return Promise.resolve(null)

  const existing = extensionLogoCache.get(extensionId)
  if (existing) {
    if (existing.status === 'ready') return Promise.resolve(existing.url)
    if (existing.status === 'error') return Promise.resolve(null)
    if (existing.status === 'loading') return existing.promise
  }

  const promise = fetchChromeWebStoreLogoUrl(extensionId)
    .then((url) => {
      extensionLogoCache.set(extensionId, { status: 'ready', url })
      return url
    })
    .catch(() => {
      extensionLogoCache.set(extensionId, { status: 'error' })
      return null
    })

  extensionLogoCache.set(extensionId, { status: 'loading', promise })
  return promise
}

function prefetchWorkspaceExtensionLogos () {
  const ids = [...new Set(
    workspaces
      .map((workspace) => workspace && workspace.extensionId)
      .filter(isValidExtensionId)
  )]
  if (ids.length === 0) return Promise.resolve()

  return Promise.all(ids.map((id) => ensureExtensionLogo(id))).then(() => {
    renderWorkspaceSwitcher()
    renderWorkspacePicker()
  })
}

function workspaceAvatarHtml (workspace, className) {
  const logoUrl = getCachedExtensionLogo(workspace && workspace.extensionId)
  if (logoUrl) {
    return `<span class="${className} ${className}--logo" aria-hidden="true"><img src="${escapeHtml(logoUrl)}" alt=""></span>`
  }
  return `<span class="${className}" aria-hidden="true">${escapeHtml(workspaceInitial(workspace))}</span>`
}

function fillWorkspaceAvatarElement (el, workspace, logoModifierClass) {
  if (!el) return
  const logoUrl = workspace ? getCachedExtensionLogo(workspace.extensionId) : null
  if (logoUrl) {
    el.classList.add(logoModifierClass)
    el.replaceChildren()
    const img = document.createElement('img')
    img.src = logoUrl
    img.alt = ''
    img.addEventListener('error', () => {
      el.classList.remove(logoModifierClass)
      el.textContent = workspaceInitial(workspace)
    })
    el.appendChild(img)
    return
  }
  el.classList.remove(logoModifierClass)
  el.textContent = workspace ? workspaceInitial(workspace) : ''
}

function renderWorkspaceSwitcher () {
  if (!workspaceSwitcher) return

  if (!currentUser) {
    workspaceSwitcher.hidden = true
    closeWorkspaceMenu()
    return
  }

  workspaceSwitcher.hidden = false

  const active = getActiveWorkspace()
  workspaceSwitcher.classList.toggle('workspace-switcher--unselected', !active)

  if (workspaceTriggerName) {
    workspaceTriggerName.textContent = active ? active.name : 'Select workspace'
  }
  if (workspaceTriggerMeta) {
    workspaceTriggerMeta.textContent = active
      ? workspaceStripeLabel(active)
      : `${workspaces.length} workspace${workspaces.length === 1 ? '' : 's'}`
  }
  fillWorkspaceAvatarElement(workspaceTriggerAvatar, active, 'workspace-switcher__avatar--logo')

  if (!workspaceOptions) return
  workspaceOptions.innerHTML = ''

  if (workspaces.length === 0) {
    const li = document.createElement('li')
    li.className = 'workspace-switcher__empty'
    li.textContent = 'No workspaces yet.'
    workspaceOptions.appendChild(li)
    return
  }

  for (const workspace of workspaces) {
    workspaceOptions.appendChild(renderWorkspaceOption(workspace))
  }
}

function renderWorkspaceOption (workspace) {
  const li = document.createElement('li')
  const btn = document.createElement('button')
  btn.type = 'button'
  btn.className = 'workspace-switcher__option'
  btn.setAttribute('role', 'menuitemradio')

  const isActive = workspace.workspaceId === currentWorkspaceId
  btn.setAttribute('aria-checked', isActive ? 'true' : 'false')
  if (isActive) btn.classList.add('is-active')

  const check = isActive
    ? '<svg class="workspace-switcher__check" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3,8.5 6.5,12 13,4.5"/></svg>'
    : ''

  btn.innerHTML = `
    ${workspaceAvatarHtml(workspace, 'workspace-switcher__option-avatar')}
    <span class="workspace-switcher__option-text">
      <span class="workspace-switcher__option-name">${escapeHtml(workspace.name || 'Untitled')}</span>
      <span class="workspace-switcher__option-meta">${escapeHtml(workspaceStripeLabel(workspace))}</span>
    </span>
    ${check}
  `

  btn.addEventListener('click', () => {
    closeWorkspaceMenu()
    selectWorkspace(workspace.workspaceId)
  })

  li.appendChild(btn)
  return li
}

function renderWorkspacePicker () {
  if (!workspacePickerList) return
  workspacePickerList.innerHTML = ''

  if (workspaces.length === 0) {
    const li = document.createElement('li')
    li.className = 'workspace-picker__empty'
    li.textContent = 'You don’t have any workspaces yet. Create one to get started.'
    workspacePickerList.appendChild(li)
    return
  }

  for (const workspace of workspaces) {
    const li = document.createElement('li')
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className = 'workspace-picker__item'
    btn.innerHTML = `
      ${workspaceAvatarHtml(workspace, 'workspace-picker__item-avatar')}
      <span class="workspace-picker__item-text">
        <span class="workspace-picker__item-name">${escapeHtml(workspace.name || 'Untitled')}</span>
        <span class="workspace-picker__item-meta">${escapeHtml(workspaceStripeLabel(workspace))}</span>
      </span>
      <svg class="workspace-picker__item-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6,4 10,8 6,12"/></svg>
    `
    btn.addEventListener('click', () => selectWorkspace(workspace.workspaceId))
    li.appendChild(btn)
    workspacePickerList.appendChild(li)
  }
}

function onWorkspaceMenuOutsideClick (event) {
  if (workspaceSwitcher && !workspaceSwitcher.contains(event.target)) closeWorkspaceMenu()
}

function onWorkspaceMenuKeydown (event) {
  if (event.key === 'Escape') {
    closeWorkspaceMenu()
    if (workspaceTrigger) workspaceTrigger.focus()
  }
}

function openWorkspaceMenu () {
  if (!workspaceMenu || !workspaceTrigger || !workspaceMenu.hidden) return
  workspaceMenu.hidden = false
  workspaceTrigger.setAttribute('aria-expanded', 'true')
  document.addEventListener('click', onWorkspaceMenuOutsideClick, true)
  document.addEventListener('keydown', onWorkspaceMenuKeydown)
}

function closeWorkspaceMenu () {
  if (!workspaceMenu || !workspaceTrigger || workspaceMenu.hidden) return
  workspaceMenu.hidden = true
  workspaceTrigger.setAttribute('aria-expanded', 'false')
  document.removeEventListener('click', onWorkspaceMenuOutsideClick, true)
  document.removeEventListener('keydown', onWorkspaceMenuKeydown)
}

function toggleWorkspaceMenu () {
  if (workspaceMenu && workspaceMenu.hidden) openWorkspaceMenu()
  else closeWorkspaceMenu()
}

async function selectWorkspace (workspaceId) {
  if (!workspaceId || workspaceId === currentWorkspaceId) return
  currentWorkspaceId = workspaceId
  setStoredWorkspaceId(workspaceId)
  syncAccountFromWorkspace(getActiveWorkspace())
  renderWorkspaceSwitcher()
  updateSiteHeader()
  await loadDashboard()
}

function onWorkspaceCreateKeydown (event) {
  if (event.key === 'Escape') closeWorkspaceCreateModal()
}

function openWorkspaceCreateModal () {
  closeWorkspaceMenu()
  if (!workspaceCreateModal) return
  workspaceCreateModal.hidden = false
  if (workspaceCreateInput) workspaceCreateInput.value = ''
  setStatus('', '', workspaceCreateStatus)
  setActionButtonState(workspaceCreateSubmit, 'idle')
  document.addEventListener('keydown', onWorkspaceCreateKeydown)
  if (workspaceCreateInput) setTimeout(() => workspaceCreateInput.focus(), 0)
}

function closeWorkspaceCreateModal () {
  if (!workspaceCreateModal || workspaceCreateModal.hidden) return
  workspaceCreateModal.hidden = true
  document.removeEventListener('keydown', onWorkspaceCreateKeydown)
}

async function submitWorkspaceCreate (event) {
  event.preventDefault()
  const name = workspaceCreateInput ? workspaceCreateInput.value.trim() : ''
  if (!name) {
    setStatus('Enter a workspace name.', 'error', workspaceCreateStatus)
    return
  }

  setActionButtonState(workspaceCreateSubmit, 'loading', { loadingLabel: 'Creating…' })
  setStatus('', '', workspaceCreateStatus)

  try {
    const workspace = await apiRequest('/dashboard/workspaces', {
      method: 'POST',
      body: JSON.stringify({ name }),
      live: true
    })
    workspaces.push(workspace)
    setActionButtonState(workspaceCreateSubmit, 'idle')
    closeWorkspaceCreateModal()
    await selectWorkspace(workspace.workspaceId)
  } catch (error) {
    setActionButtonState(workspaceCreateSubmit, 'idle')
    setStatus(error.message || 'Could not create workspace.', 'error', workspaceCreateStatus)
  }
}

function populateWorkspaceSettingsForm () {
  const workspace = getActiveWorkspace()
  if (!workspace) return
  if (workspaceNameInput) workspaceNameInput.value = workspace.name || ''
  if (workspaceExtensionInput) workspaceExtensionInput.value = workspace.extensionId || ''
}

async function saveSettings (event) {
  event.preventDefault()
  if (!currentWorkspaceId) return

  const primaryColor = normalizeHexColorInput(brandingPrimaryColorText.value)
  if (!primaryColor) {
    setFormSaveState(settingsSaveBtn, settingsStatus, 'error', 'Primary color is invalid. Open Branding to fix it.')
    return
  }

  setFormSaveState(settingsSaveBtn, settingsStatus, 'loading')

  const name = workspaceNameInput ? workspaceNameInput.value.trim() : undefined
  const extensionId = workspaceExtensionInput ? workspaceExtensionInput.value.trim() : undefined

  try {
    const [updated, brandingData] = await Promise.all([
      apiRequest(`/dashboard/workspaces/${encodeURIComponent(currentWorkspaceId)}`, {
        method: 'PATCH',
        body: JSON.stringify({ name, extensionId: extensionId || null }),
        live: true
      }),
      apiRequest('/dashboard/branding', {
        method: 'PUT',
        body: JSON.stringify({
          primaryColor,
          logoUrl: brandingLogoUrl.value.trim(),
          emailDomainAlias: emailDomainAliasInput ? emailDomainAliasInput.value.trim() : undefined,
          linkBaseUrl: linkBaseUrlInput ? linkBaseUrlInput.value.trim() : undefined
        })
      })
    ])
    workspaces = workspaces.map((w) => (w.workspaceId === updated.workspaceId ? updated : w))
    if (updated.extensionId && extensionLogoCache.get(updated.extensionId)?.status === 'error') {
      extensionLogoCache.delete(updated.extensionId)
    }
    if (linkBaseUrlInput) linkBaseUrlInput.value = brandingData.linkBaseUrl || ''
    renderWorkspaceSwitcher()
    prefetchWorkspaceExtensionLogos()
    setFormSaveState(settingsSaveBtn, settingsStatus, 'success')
  } catch (error) {
    setFormSaveState(settingsSaveBtn, settingsStatus, 'error', error.message || 'Failed to save settings.')
  }
}

function normalizeHexColorInput (value) {
  if (!value || typeof value !== 'string') return null
  const trimmed = value.trim()
  if (!/^#[0-9A-Fa-f]{6}$/.test(trimmed)) return null
  return trimmed.toLowerCase()
}

function syncBrandingColorInputs (color) {
  if (!brandingPrimaryColor || !brandingPrimaryColorText) return
  brandingPrimaryColor.value = color
  brandingPrimaryColorText.value = color
}

function renderEmailPreview () {
  if (!emailPreviewShell || !emailPreviewHeader) return

  const primaryColor = normalizeHexColorInput(brandingPrimaryColorText.value) || '#6eb8eb'
  const logoUrl = brandingLogoUrl.value.trim()

  emailPreviewShell.style.backgroundColor = primaryColor
  emailPreviewHeader.replaceChildren()

  if (logoUrl) {
    const img = document.createElement('img')
    img.src = logoUrl
    img.alt = emailAccountName || 'Logo preview'
    img.addEventListener('error', () => {
      emailPreviewHeader.replaceChildren()
      const fallback = document.createElement('p')
      fallback.className = 'email-preview__header-name'
      fallback.textContent = emailAccountName || 'Your account'
      emailPreviewHeader.appendChild(fallback)
    })
    emailPreviewHeader.appendChild(img)
    return
  }

  const name = document.createElement('p')
  name.className = 'email-preview__header-name'
  name.textContent = emailAccountName || 'Your account'
  emailPreviewHeader.appendChild(name)
}

function setBrandingStatus (message, type = 'loading') {
  setStatus(message, type, brandingStatus)
}

async function copyText (text, button) {
  try {
    await navigator.clipboard.writeText(text)
    const original = button.textContent
    button.textContent = 'Copied!'
    window.setTimeout(() => {
      button.textContent = original
    }, 1600)
  } catch {
    window.prompt('Copy this setup text:', text)
  }
}

function getPayhookSetupBasics () {
  const accountId = getStoredAccountId() || 'acct_xxx'
  return {
    accountId,
    mode: getTestMode() ? 'Test mode' : 'Live mode',
    dashboardUrl: 'https://dashboard.payhook.link',
    agentUrl: 'https://mcp.payhook.link/'
  }
}

function buildWebsiteSetupBrief () {
  const setup = getPayhookSetupBasics()

  return [
    'Payhook website setup brief',
    '',
    'Paste this into the AI builder or site editor updating my product.',
    '',
    'Payhook details:',
    `- Account ID: ${setup.accountId}`,
    `- Mode: ${setup.mode}`,
    `- Dashboard: ${setup.dashboardUrl}`,
    `- Payhook Agent URL, if the builder supports connected tools: ${setup.agentUrl}`,
    '',
    'Goal:',
    '- Add a Payhook unlock button where paid access starts.',
    '- Use the Stripe products and prices connected to this Payhook account.',
    '- Send customers through Payhook hosted checkout and Stripe.',
    '- Unlock the paid feature after payment succeeds.',
    '- Keep subscriptions, billing links, access checks, and unlock emails behind Payhook.',
    '',
    'Important:',
    '- Do not build a custom Stripe backend.',
    '- Do not connect directly to Payhook internals.',
    '- Use the Payhook Agent or Payhook dashboard setup when payment details are needed.',
    '- Do not show me raw implementation code unless I ask for it.'
  ].join('\n')
}

function formatSetupValue (value, fallback) {
  return value && String(value).trim() ? String(value).trim() : fallback
}

function buildExtensionSetupBrief () {
  const setup = getPayhookSetupBasics()
  const primaryColor = formatSetupValue(brandingPrimaryColorText && brandingPrimaryColorText.value, '#6eb8eb')

  return [
    'Payhook Chrome extension setup brief',
    '',
    'Paste this into the AI builder updating my Chrome extension.',
    '',
    'Payhook details:',
    `- Account ID: ${setup.accountId}`,
    `- Mode: ${setup.mode}`,
    `- Dashboard: ${setup.dashboardUrl}`,
    `- Payhook Agent URL, if the builder supports connected tools: ${setup.agentUrl}`,
    `- Primary color: ${primaryColor}`,
    '',
    'Goal:',
    '- Add the Payhook upgrade button to the extension popup, settings page, or another visible upgrade location.',
    '- Gate premium features with Payhook payment state.',
    '- Send unpaid users through Payhook hosted checkout and Stripe.',
    '- Restore paid access for returning customers when their payment state is active.',
    '- Use the Stripe products and prices connected to this Payhook account.',
    '',
    'Important:',
    '- Do not build a custom Stripe backend or license server.',
    '- Do not connect directly to Payhook internals.',
    '- Use the Payhook Agent or Payhook dashboard setup when payment details are needed.',
    '- Keep Payhook as the payment and access black box.',
    '- Do not show me raw implementation code unless I ask for it.'
  ].join('\n')
}

const settingsLoadingStatus = document.getElementById('settings-loading-status')
const brandingLoadingStatus = document.getElementById('branding-loading-status')
const buttonLoadingStatus = document.getElementById('button-loading-status')
const successLoadingStatus = document.getElementById('success-loading-status')
const trialUsageLoadingStatus = document.getElementById('trial-usage-loading-status')
const buttonContent = document.getElementById('button-content')
const successContent = document.getElementById('success-content')
const trialUsageContent = document.getElementById('trial-usage-content')
const productCatalogLoadingStatus = document.getElementById('product-catalog-loading-status')
const productCatalogContent = document.getElementById('product-catalog-content')
const productCatalogTabsNavEl = document.getElementById('product-catalog-tabs')
const catalogTabPanes = () => document.querySelectorAll('[data-catalog-tab-pane]')

function setSettingsLoadingStatus (message, type = 'loading') {
  if (!settingsLoadingStatus) return
  setStatus(message, type, settingsLoadingStatus)
}

function setBrandingLoadingStatus (message, type = 'loading') {
  if (!brandingLoadingStatus) return
  setStatus(message, type, brandingLoadingStatus)
}

function setButtonLoadingStatus (message, type = 'loading') {
  if (!buttonLoadingStatus) return
  setStatus(message, type, buttonLoadingStatus)
}

function setSuccessLoadingStatus (message, type = 'loading') {
  if (!successLoadingStatus) return
  setStatus(message, type, successLoadingStatus)
}

function setTrialUsageLoadingStatus (message, type = 'loading') {
  if (!trialUsageLoadingStatus) return
  setStatus(message, type, trialUsageLoadingStatus)
}

function setProductCatalogLoadingStatus (message, type = 'loading') {
  if (!productCatalogLoadingStatus) return
  setStatus(message, type, productCatalogLoadingStatus)
}

function showButtonContent () {
  if (buttonContent) buttonContent.hidden = false
}

function hideButtonContent () {
  if (buttonContent) buttonContent.hidden = true
}

function showSuccessContent () {
  if (successContent) successContent.hidden = false
}

function hideSuccessContent () {
  if (successContent) successContent.hidden = true
}

function showTrialUsageContent () {
  if (trialUsageContent) trialUsageContent.hidden = false
}

function hideTrialUsageContent () {
  if (trialUsageContent) trialUsageContent.hidden = true
}

function getActiveCatalogTab () {
  const fromUrl = getCatalogTabFromUrl()
  if (fromUrl) return fromUrl
  const btn = productCatalogTabsNavEl && productCatalogTabsNavEl.querySelector('.settings-tabs__btn.is-active')
  return btn ? btn.dataset.catalogTab : 'catalog'
}

function activateCatalogTab (tab) {
  tab = normalizeCatalogTab(tab) || 'catalog'
  if (!PRODUCT_CATALOG_TABS.includes(tab)) tab = 'catalog'
  if (productCatalogTabsNavEl) {
    productCatalogTabsNavEl.querySelectorAll('.settings-tabs__btn').forEach((b) => {
      const active = b.dataset.catalogTab === tab
      b.classList.toggle('is-active', active)
      b.setAttribute('aria-selected', String(active))
    })
  }
  catalogTabPanes().forEach((pane) => {
    pane.hidden = pane.dataset.catalogTabPane !== tab
  })
}

function showProductCatalogContent () {
  if (productCatalogContent) productCatalogContent.hidden = false
  if (productCatalogTabsNavEl) productCatalogTabsNavEl.hidden = false
  activateCatalogTab(getActiveCatalogTab())
}

function hideProductCatalogContent () {
  if (productCatalogContent) productCatalogContent.hidden = true
  if (productCatalogTabsNavEl) productCatalogTabsNavEl.hidden = true
  catalogTabPanes().forEach((pane) => { pane.hidden = true })
}

async function loadSettings () {
  setSettingsLoadingStatus('Loading settings…', 'loading')
  populateWorkspaceSettingsForm()

  try {
    const brandingData = await apiRequest('/dashboard/branding')
    if (emailDomainAliasInput) emailDomainAliasInput.value = brandingData.emailDomainAlias || ''
    if (linkBaseUrlInput) linkBaseUrlInput.value = brandingData.linkBaseUrl || ''
    if (brandingData.branding) {
      syncBrandingColorInputs(brandingData.branding.primaryColor)
      if (brandingLogoUrl) brandingLogoUrl.value = brandingData.branding.logoUrl || ''
      brandingReady = true
    }
    setSettingsLoadingStatus('')
  } catch (error) {
    setSettingsLoadingStatus(error.message || 'Failed to load settings.', 'error')
  }
}

async function loadBrandingSection () {
  if (brandingReady) {
    setBrandingLoadingStatus('')
    if (activeSection === 'branding') showBrandingPreview()
    return
  }

  setBrandingLoadingStatus('Loading branding…', 'loading')
  setRightPanelPreviewLoading(true)

  try {
    const brandingData = await apiRequest('/dashboard/branding')
    const { primaryColor, logoUrl } = brandingData.branding

    syncBrandingColorInputs(primaryColor)
    brandingLogoUrl.value = logoUrl || ''
    if (emailDomainAliasInput) emailDomainAliasInput.value = brandingData.emailDomainAlias || ''
    if (linkBaseUrlInput) linkBaseUrlInput.value = brandingData.linkBaseUrl || ''
    brandingReady = true
    setBrandingLoadingStatus('')
    if (activeSection === 'branding') showBrandingPreview()
  } catch (error) {
    brandingReady = false
    const message = error.message || 'Failed to load branding.'
    setBrandingLoadingStatus(message, 'error')
    if (activeSection === 'branding') {
      setRightPanelPreviewLoading(true, message)
    }
  }
}

async function loadButtonSection () {
  buttonSectionReady = false
  hideButtonContent()
  hideSuccessContent()
  hideTrialUsageContent()
  hideProductCatalogContent()
  setButtonLoadingStatus('Loading unlock settings…', 'loading')
  setSuccessLoadingStatus('Loading unlock settings…', 'loading')
  setTrialUsageLoadingStatus('Loading unlock settings…', 'loading')
  setProductCatalogLoadingStatus('Loading unlock settings…', 'loading')
  setRightPanelPreviewLoading(true)

  try {
    const [brandingData, unlockData] = await Promise.all([
      apiRequest('/dashboard/branding'),
      apiRequest('/dashboard/unlock_settings')
    ])
    const { primaryColor, logoUrl } = brandingData.branding

    syncBrandingColorInputs(primaryColor)
    brandingLogoUrl.value = logoUrl || ''
    if (emailDomainAliasInput) emailDomainAliasInput.value = brandingData.emailDomainAlias || ''
    if (linkBaseUrlInput) linkBaseUrlInput.value = brandingData.linkBaseUrl || ''
    brandingReady = true
    renderEmailPreview()

    applyUnlockSettings(unlockData)
    setUnlockStatus('')
    buttonSectionReady = true
    setButtonLoadingStatus('')
    setSuccessLoadingStatus('')
    setTrialUsageLoadingStatus('')
    setProductCatalogLoadingStatus('')
    showButtonContent()
    showSuccessContent()
    showTrialUsageContent()
    showProductCatalogContent()
    if (activeSection === 'button') {
      showButtonPreview()
    } else if (activeSection === 'success') {
      showSuccessPreview()
    } else if (activeSection === 'trial-usage') {
      showTrialUsagePreview()
    } else if (activeSection === 'product-catalog') {
      showProductCatalogPreview()
    }
  } catch (error) {
    buttonSectionReady = false
    const message = error.message || 'Failed to load unlock settings.'
    setButtonLoadingStatus(message, 'error')
    setSuccessLoadingStatus(message, 'error')
    setTrialUsageLoadingStatus(message, 'error')
    setProductCatalogLoadingStatus(message, 'error')
    if (
      activeSection === 'button' ||
      activeSection === 'product-catalog' ||
      activeSection === 'success' ||
      activeSection === 'trial-usage'
    ) {
      setRightPanelPreviewLoading(true, message)
    }
  }
}

if (workspaceTrigger) workspaceTrigger.addEventListener('click', toggleWorkspaceMenu)
if (workspaceNewBtn) workspaceNewBtn.addEventListener('click', openWorkspaceCreateModal)
if (workspacePickerNewBtn) workspacePickerNewBtn.addEventListener('click', openWorkspaceCreateModal)
if (workspaceCreateForm) workspaceCreateForm.addEventListener('submit', submitWorkspaceCreate)
if (workspaceCreateCancel) workspaceCreateCancel.addEventListener('click', closeWorkspaceCreateModal)
if (workspaceCreateModal) {
  workspaceCreateModal.addEventListener('click', (e) => {
    if (e.target === workspaceCreateModal) closeWorkspaceCreateModal()
  })
}
if (settingsForm) settingsForm.addEventListener('submit', saveSettings)

async function saveBranding (event) {
  event.preventDefault()

  const primaryColor = normalizeHexColorInput(brandingPrimaryColorText.value)
  if (!primaryColor) {
    setFormSaveState(brandingSaveBtn, brandingStatus, 'error', 'Enter a valid hex primary color like #6eb8eb.')
    return
  }

  setFormSaveState(brandingSaveBtn, brandingStatus, 'loading')

  try {
    const data = await apiRequest('/dashboard/branding', {
      method: 'PUT',
      body: JSON.stringify({
        primaryColor,
        logoUrl: brandingLogoUrl.value.trim(),
        emailDomainAlias: emailDomainAliasInput ? emailDomainAliasInput.value.trim() : undefined,
        linkBaseUrl: linkBaseUrlInput ? linkBaseUrlInput.value.trim() : undefined
      })
    })

    syncBrandingColorInputs(data.branding.primaryColor)
    brandingLogoUrl.value = data.branding.logoUrl || ''
    if (emailDomainAliasInput) emailDomainAliasInput.value = data.emailDomainAlias || ''
    if (linkBaseUrlInput) linkBaseUrlInput.value = data.linkBaseUrl || ''
    renderEmailPreview()
    hostedUnlockPreviewKey = null
    hostedUnlockSuccessPreviewKey = null
    setFormSaveState(brandingSaveBtn, brandingStatus, 'success')
  } catch (error) {
    setFormSaveState(brandingSaveBtn, brandingStatus, 'error', error.message || 'Failed to save settings.')
  }
}

function overviewStatusEl () {
  if (activeSection === 'overview') return overviewStatus
  if (activeSection === 'analytics') return analyticsStatus
  return null
}

function renderDashboard (data) {
  overviewLoaded = true
  statsPanel.hidden = false
  if (overviewStatus) setStatus('', 'loading', overviewStatus)
  if (analyticsStatus) setStatus('', 'loading', analyticsStatus)

  const displayName = data.account.displayName || data.account.id
  emailAccountName = displayName
  setStoredAccountLabel(displayName)
  updateSiteHeader()

  const range = analyticsRange()
  syncAnalyticsRangeCopy(range)

  const { summary } = data
  const unlockClickTotal = data.tracking && data.tracking.unlock_click
    ? data.tracking.unlock_click.total
    : 0

  statsGrid.replaceChildren(
    renderStatCard('Available balance', formatMoney(summary.availableBalance, summary.currency)),
    renderStatCard('Pending balance', formatMoney(summary.pendingBalance, summary.currency)),
    renderStatCard('Customers', summary.customers),
    renderStatCard('Active subscriptions', summary.activeSubscriptions),
    renderStatCard('Recent charges', summary.charges),
    renderStatCard(`Unlock clicks (${range.short})`, unlockClickTotal)
  )

  renderActivityChart(data.activity)
  renderUnlockCountries(data.tracking)
}

async function loadDashboardOverview () {
  if (overviewLoaded) return
  if (overviewLoading) return overviewLoading

  const generation = dashboardGeneration
  const range = analyticsRange()
  syncAnalyticsRangeCopy(range)
  const statusEl = overviewStatusEl()
  if (statusEl) {
    setStatus(
      activeSection === 'overview' ? 'Loading overview…' : 'Loading analytics…',
      'loading',
      statusEl
    )
  }

  overviewLoading = apiRequest(`/dashboard/overview?days=${range.days}`)
    .then((data) => {
      if (generation === dashboardGeneration) renderDashboard(data)
    })
    .catch((error) => {
      if (generation !== dashboardGeneration) return
      if (error.status === 401 || error.status === 410) {
        currentUser = null
        currentAccount = null
        clearStoredAccountId()
        showAuthView({ message: 'Sign in again to continue.' })
        return
      }

      if (error.status === 409) {
        currentAccount = null
        clearStoredAccountId()
        showConnectView({ message: 'Connect Stripe to finish setting up your dashboard.' })
        return
      }

      const errEl = overviewStatusEl()
      if (errEl) {
        setStatus(
          error.message || (activeSection === 'overview' ? 'Failed to load overview.' : 'Failed to load analytics.'),
          'error',
          errEl
        )
      }
    })
    .finally(() => {
      if (generation === dashboardGeneration) overviewLoading = null
    })

  return overviewLoading
}

function setAnalyticsWindow (value) {
  const next = analyticsRange(value)
  if (next.value === analyticsWindow) {
    syncAnalyticsRangeCopy(next)
    return
  }
  analyticsWindow = next.value
  overviewLoaded = false
  overviewLoading = null
  productSalesLoaded = false
  featureUsageStatsLoaded = false
  syncAnalyticsRangeCopy(next)
  if (activeSection === 'overview' || activeSection === 'analytics') {
    loadDashboardOverview()
    if (activeSection === 'analytics') loadFeatureUsageStats({ force: true })
  } else if (activeSection === 'sales') loadProductSales({ force: true })
}

function showDashboardShell () {
  showDashboardView()
  if (!isEmbedMode()) {
    dashSidebar.hidden = false
    if (modeToggle) modeToggle.hidden = false
    updateModeToggle()
    mountSetupWizard({
      container: document.getElementById('setup-wizard'),
      accountId: currentAccount.accountId,
      stripeConnected: true,
      apiRequest,
      getTestMode,
      onNavigate: navigateTo
    })
  }
  navigateTo(activeSection, { replace: true })
  showDashboardContent()
}

async function loadDashboard () {
  dashboardGeneration++
  hooksLoaded = false
  paymentsLoaded = false
  productSalesLoaded = false
  featureUsageStatsLoaded = false
  overviewLoaded = false
  overviewLoading = null
  settingsLoaded = false
  brandingLoaded = false
  brandingReady = false
  buttonLoaded = false
  buttonSectionReady = false
  apiKeysLoaded = false
  apiConsoleKeysLoaded = false
  experimentsLoaded = false

  // The catalog is account/mode-specific and is fetched only when a section
  // needs it, rather than competing with the initial dashboard render.
  resetProductCatalog()
  statsPanel.hidden = true
  activityPanel.hidden = true
  activityCountriesPanel.hidden = true
  if (featureUsageStatsPanel) featureUsageStatsPanel.hidden = true
  if (featureUsageChartPanel) featureUsageChartPanel.hidden = true
  if (featureUsageCountriesPanel) featureUsageCountriesPanel.hidden = true
  if (productSalesPanel) productSalesPanel.hidden = true
  if (priceSalesPanel) priceSalesPanel.hidden = true

  if (!currentUser) {
    showAuthView()
    return
  }

  // No default workspace — require an explicit selection before anything else.
  if (!currentWorkspaceId) {
    showWorkspacePicker()
    return
  }

  if (!currentAccount || !currentAccount.accountId) {
    showConnectView({ message: 'Connect Stripe to finish setting up your dashboard.' })
    return
  }

  setStoredAccountId(currentAccount.accountId)
  showDashboardShell()
}

async function exchangeOAuthCode (code) {
  showDashboardView()
  showDashboardLoading('Connecting Stripe account…')

  const result = await apiRequest('/dashboard/accounts/connect', {
    method: 'POST',
    body: JSON.stringify({ code }),
    live: true
  })

  setStoredAccountId(result.accountId)
  stripOAuthParamsFromUrl()
  await loadBootstrap().catch(() => {
    currentAccount = { accountId: result.accountId }
    setStoredAccountId(result.accountId)
  })
  if (!currentAccount || !currentAccount.accountId) {
    currentAccount = { accountId: result.accountId }
    setStoredAccountId(result.accountId)
  }
}

async function createPaymentHook () {
  setActionButtonState(createHookBtn, 'loading', { loadingLabel: 'Creating…' })

  try {
    await apiRequest('/v1/payment_hooks', { method: 'POST' })
    setActionButtonState(createHookBtn, 'success', { successLabel: 'Created' })
    await loadDashboard()
  } catch (error) {
    setActionButtonState(createHookBtn, 'error')
    setStatus(error.message || 'Failed to create hook.', 'error', hooksStatus)
  }
}

function escapeHtml (value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

const RAW_HTML_MARKER = Symbol('rawHtml')

// Explicit opt-in for a renderTable() column that legitimately needs to render
// markup instead of plain text. Any HTML string not wrapped in rawHtml() is
// treated as untrusted and rendered as plain text (see renderTable()).
function rawHtml (html) {
  return { [RAW_HTML_MARKER]: true, html }
}

function renderDataToken (value) {
  return `<span class="data-token">${escapeHtml(value)}</span>`
}

function renderTable (columns, rows, { onRow, emptyMessage = 'No results found.' } = {}) {
  if (!rows.length) {
    const p = document.createElement('p')
    p.className = 'data-table__empty'
    p.textContent = emptyMessage
    return p
  }

  const table = document.createElement('table')
  table.className = 'data-table'

  const thead = table.createTHead()
  const headerRow = thead.insertRow()
  columns.forEach(col => {
    const th = document.createElement('th')
    th.textContent = col.label
    headerRow.appendChild(th)
  })

  const tbody = table.createTBody()
  rows.forEach(row => {
    const tr = tbody.insertRow()
    if (onRow) {
      tr.classList.add('is-clickable')
      tr.setAttribute('role', 'button')
      tr.tabIndex = 0
      tr.addEventListener('click', () => onRow(row, tr))
      tr.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return
        event.preventDefault()
        onRow(row, tr)
      })
    }
    columns.forEach(col => {
      const td = tr.insertCell()
      const val = row[col.key]
      if (col.render) {
        const content = col.render(val, row)
        if (content && typeof content === 'object' && content[RAW_HTML_MARKER]) {
          // Explicitly marked via rawHtml() — the caller is responsible for
          // having escaped any untrusted data embedded in this markup.
          td.innerHTML = content.html
        } else if (typeof content === 'string') {
          // Raw strings are never treated as HTML. This is the safe default:
          // a column that returns unescaped user input can't reintroduce XSS.
          td.textContent = content
        } else {
          td.appendChild(content)
        }
      } else {
        td.textContent = val != null ? String(val) : '—'
      }
    })
  })

  return table
}

function renderPaginationBar (container, { page, total, limit, hasMore }, onPage) {
  const start = total > 0 ? (page - 1) * limit + 1 : 0
  const end = Math.min(page * limit, total)

  const info = document.createElement('span')
  info.className = 'pagination-bar__info'
  info.textContent = total > 0 ? `${start}–${end} of ${total}` : '0 results'

  const buttons = document.createElement('div')
  buttons.className = 'pagination-bar__buttons'

  const prevBtn = document.createElement('button')
  prevBtn.className = 'btn btn--ghost btn--sm'
  prevBtn.textContent = '← Prev'
  prevBtn.disabled = page <= 1
  prevBtn.addEventListener('click', () => onPage(page - 1))

  const nextBtn = document.createElement('button')
  nextBtn.className = 'btn btn--ghost btn--sm'
  nextBtn.textContent = 'Next →'
  nextBtn.disabled = !hasMore
  nextBtn.addEventListener('click', () => onPage(page + 1))

  buttons.append(prevBtn, nextBtn)
  container.replaceChildren(info, buttons)
}

async function loadPaymentHooks () {
  const { page, range: rangeValue } = hooksState
  const params = new URLSearchParams({ page })
  const range = analyticsRange(rangeValue)
  if (range.value !== 'all') params.set('days', String(range.days))

  hooksStatus.hidden = false
  hooksStatus.textContent = 'Loading…'
  hooksStatus.className = 'dashboard-status dashboard-status--loading'
  hooksTableWrap.replaceChildren()
  hooksPagination.replaceChildren()

  try {
    const data = await apiRequest(`/dashboard/payment_hooks?${params}`)
    hooksStatus.hidden = true

    const columns = [
      { key: 'id', label: 'ID', render: val => rawHtml(renderDataToken(val)) },
      { key: 'createdAt', label: 'Created', render: val => val ? new Date(val).toLocaleString() : '—' },
      {
        key: 'id',
        label: '',
        render: (val) => rawHtml(
          `<button class="btn btn--ghost btn--sm" type="button" data-api-console-hook="${escapeAttr(val)}">API console</button>`
        )
      }
    ]

    hooksTableWrap.replaceChildren(renderTable(columns, data.items))
    hooksTableWrap.querySelectorAll('[data-api-console-hook]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.stopPropagation()
        openApiConsole({ endpoint: 'pull', paymentHookId: btn.getAttribute('data-api-console-hook') })
      })
    })
    renderPaginationBar(hooksPagination, data, (newPage) => {
      hooksState.page = newPage
      loadPaymentHooks()
    })
  } catch (error) {
    hooksStatus.hidden = false
    hooksStatus.textContent = error.message || 'Failed to load installs.'
    hooksStatus.className = 'dashboard-status dashboard-status--error'
  }
}

async function fetchPaymentHookRequests (id) {
  if (!hookLookupRequests || !hookLookupRequestsTable) return

  hookLookupRequests.hidden = false
  hookLookupRequestsTable.replaceChildren()
  setStatus('Loading API request traces…', 'loading', hookLookupRequestsStatus)

  try {
    const hours = getHookLookupHoursFromUrl()
    const params = new URLSearchParams({ hours: String(hours), limit: '100' })
    const data = await apiRequest(
      `/dashboard/payment_hooks/${encodeURIComponent(id)}/requests?${params}`
    )
    const rows = data.requests || []
    if (!rows.length) {
      setStatus(`No ACCESS traces in the last ${data.hours || hours}h for this install.`, 'idle', hookLookupRequestsStatus)
      const empty = document.createElement('p')
      empty.className = 'data-table__empty'
      empty.textContent = 'No recent API requests.'
      hookLookupRequestsTable.replaceChildren(empty)
      return
    }

    setStatus(`${rows.length} request${rows.length === 1 ? '' : 's'} in the last ${data.hours || hours}h. Click a row for details.`, 'idle', hookLookupRequestsStatus)
    hookLookupRequestsTable.replaceChildren(renderTable([
      {
        key: 'timestamp',
        label: 'When',
        render: (val) => val ? new Date(val).toLocaleString() : '—'
      },
      { key: 'method', label: 'Method' },
      {
        key: 'path',
        label: 'URL',
        render: (val, row) => val || row.url || '—'
      },
      {
        key: 'query',
        label: 'Query',
        render: (val) => {
          if (!val || typeof val !== 'object') return '—'
          return Object.keys(val).join(', ') || '—'
        }
      }
    ], rows, { onRow: showAccessRequestDetail }))
  } catch (error) {
    setStatus(error.message || 'Failed to load request traces.', 'error', hookLookupRequestsStatus)
  }
}

function getPaymentHookIdFromUrl () {
  const params = new URLSearchParams(window.location.search)
  return (params.get('paymentHookId') || params.get('hookId') || '').trim() || null
}

function getHookLookupHoursFromUrl () {
  const hours = Number(new URLSearchParams(window.location.search).get('hours'))
  if (!Number.isFinite(hours) || hours < 1) return 24
  return Math.min(168, Math.floor(hours))
}

/** True when loaded as a chromeless iframe (e.g. embedded in console.slowed.app/debug/) — strips the app rail, sidebar, and hooks list down to just the ACCESS traces lookup. */
function isEmbedMode () {
  return new URLSearchParams(window.location.search).get('embed') === '1'
}

/** Show/hide the left app rail. Always stays hidden in ?embed=1 so the iframe is chromeless. */
function setAppRailVisible (visible) {
  if (appRail) appRail.hidden = isEmbedMode() ? true : !visible
}

function setPaymentHookIdInUrl (id, { replace = true } = {}) {
  const url = new URL(window.location.href)
  if (id) url.searchParams.set('paymentHookId', id)
  else url.searchParams.delete('paymentHookId')
  url.searchParams.delete('hookId')
  const hours = getHookLookupHoursFromUrl()
  if (hours !== 24) url.searchParams.set('hours', String(hours))
  else url.searchParams.delete('hours')
  const state = getHistoryState()
  if (replace) window.history.replaceState(state, '', url.toString())
  else window.history.pushState(state, '', url.toString())
}

function showAccessRequestDetail (row) {
  const modal = document.getElementById('request-detail-modal')
  const body = document.getElementById('request-detail-modal-body')
  const title = document.getElementById('request-detail-modal-title')
  if (!modal || !body || !title) return

  const method = row.method || '?'
  const path = row.path || row.url || '—'
  title.textContent = `${method} ${path}`
  body.replaceChildren()

  const summary = document.createElement('div')
  summary.className = 'request-detail__summary'
  summary.innerHTML = `
    <span class="badge badge--ok">${escapeHtml(method)}</span>
    <time class="request-detail__time">${escapeHtml(row.timestamp ? new Date(row.timestamp).toLocaleString() : '—')}</time>
  `
  body.appendChild(summary)

  const fields = [
    ['Path', path],
    ['Query string', row.queryString || null],
    ['Payment hook', row.paymentHookId]
  ]
  const list = document.createElement('dl')
  list.className = 'request-detail__list'
  for (const [label, value] of fields) {
    if (!value) continue
    const item = document.createElement('div')
    item.className = 'request-detail__row'
    item.innerHTML = `
      <dt class="request-detail__key">${escapeHtml(label)}</dt>
      <dd class="request-detail__value">${escapeHtml(value)}</dd>
    `
    list.appendChild(item)
  }

  const queryRow = document.createElement('div')
  queryRow.className = 'request-detail__row'
  const queryKey = document.createElement('dt')
  queryKey.className = 'request-detail__key'
  queryKey.textContent = 'Query params'
  const queryValue = document.createElement('dd')
  queryValue.className = 'request-detail__value'
  const pre = document.createElement('pre')
  pre.className = 'request-detail__pre'
  pre.textContent = row.query ? JSON.stringify(row.query, null, 2) : 'null'
  queryValue.appendChild(pre)
  queryRow.append(queryKey, queryValue)
  list.appendChild(queryRow)
  body.appendChild(list)

  modal.hidden = false
  document.body.classList.add('modal-open')
  document.getElementById('request-detail-modal-close')?.focus()
}

function closeAccessRequestDetail () {
  const modal = document.getElementById('request-detail-modal')
  if (!modal || modal.hidden) return
  modal.hidden = true
  document.body.classList.remove('modal-open')
}

async function fetchPaymentHook () {
  const id = hookIdInput.value.trim()
  if (!id) return

  if (hookLookupBlock) hookLookupBlock.hidden = false
  if (hookLookupToggleBtn) hookLookupToggleBtn.setAttribute('aria-expanded', 'true')
  setPaymentHookIdInUrl(id)

  hookLookupResult.replaceChildren()
  if (hookLookupRequests) hookLookupRequests.hidden = true
  if (hookLookupRequestsTable) hookLookupRequestsTable.replaceChildren()
  setStatus('', 'idle', hookLookupRequestsStatus)
  setActionButtonState(hookFetchBtn, 'loading', { loadingLabel: 'Fetching…' })
  setStatus('', 'idle', hookLookupStatus)

  try {
    const hook = await apiRequest(`/dashboard/payment_hooks/${encodeURIComponent(id)}`)
    setActionButtonState(hookFetchBtn, 'success', { successLabel: 'Fetched' })

    const card = document.createElement('div')
    card.className = 'hook-detail-card'

    const rows = [
      ['ID', renderDataToken(hook.id)],
      ...(hook.testMode
        ? [['Mode', '<span class="badge badge--warn">test-mode</span>']]
        : []),
      ['Created', hook.createdAt ? new Date(hook.createdAt).toLocaleString() : '—'],
      [
        'API',
        `<button class="btn btn--ghost btn--sm" type="button" data-api-console-hook="${escapeAttr(hook.id)}">Open API console</button>`
      ]
    ]

    card.innerHTML = rows
      .map(([label, value]) => `<div class="hook-detail-card__row"><span class="hook-detail-card__label">${label}</span><span class="hook-detail-card__value">${value}</span></div>`)
      .join('')

    hookLookupResult.replaceChildren(card)
    card.querySelector('[data-api-console-hook]')?.addEventListener('click', () => {
      openApiConsole({ endpoint: 'pull', paymentHookId: hook.id })
    })
    await fetchPaymentHookRequests(id)
  } catch (error) {
    setActionButtonState(hookFetchBtn, 'error')
    setStatus(error.message || 'Payment hook not found.', 'error', hookLookupStatus)
  }
}

function requestSlowedExtensionPaymentHookId () {
  return new Promise((resolve) => {
    const runtime = globalThis.chrome?.runtime
    if (!runtime?.sendMessage) {
      resolve(null)
      return
    }
    try {
      runtime.sendMessage(
        SLOWED_EXTENSION_ID,
        { command: 'get-payment-hook-id' },
        (response) => {
          if (runtime.lastError) {
            resolve(null)
            return
          }
          resolve(response?.paymentHookId || null)
        }
      )
    } catch (_) {
      resolve(null)
    }
  })
}

async function maybePrefillHookIdFromSlowedExtension () {
  if (!hookIdInput || hookIdInput.value.trim()) return
  const paymentHookId = await requestSlowedExtensionPaymentHookId()
  if (!paymentHookId) return
  hookIdInput.value = paymentHookId
  hookIdInput.placeholder = 'From Slowed extension'
}

let hookLookupFromUrlPromise = null

async function maybeOpenHookLookupFromUrl () {
  const id = getPaymentHookIdFromUrl()
  if (!id || !hookIdInput) return
  if (hookIdInput.value.trim() === id && hookLookupRequests && !hookLookupRequests.hidden) {
    return
  }
  if (hookLookupFromUrlPromise) return hookLookupFromUrlPromise

  hookLookupFromUrlPromise = (async () => {
    hookIdInput.value = id
    if (hookLookupBlock) hookLookupBlock.hidden = false
    if (hookLookupToggleBtn) hookLookupToggleBtn.setAttribute('aria-expanded', 'true')
    await fetchPaymentHook()
  })().finally(() => {
    hookLookupFromUrlPromise = null
  })

  return hookLookupFromUrlPromise
}

async function fetchPayment () {
  const id = paymentIdInput.value.trim()
  if (!id) return

  if (paymentLookupBlock) paymentLookupBlock.hidden = false
  if (paymentLookupToggleBtn) paymentLookupToggleBtn.setAttribute('aria-expanded', 'true')

  paymentLookupResult.replaceChildren()
  setActionButtonState(paymentFetchBtn, 'loading', { loadingLabel: 'Fetching…' })
  setStatus('', 'idle', paymentLookupStatus)

  try {
    const payment = await apiRequest(`/dashboard/payments/${encodeURIComponent(id)}`)
    setActionButtonState(paymentFetchBtn, 'success', { successLabel: 'Fetched' })

    const card = document.createElement('div')
    card.className = 'hook-detail-card'

    const rows = [
      ['ID', renderDataToken(payment.id)],
      ['Email', escapeHtml(payment.email || '—')],
      ['Product', payment.productId ? renderDataToken(payment.productId) : '—'],
      ['Price', payment.priceId ? renderDataToken(payment.priceId) : '—'],
      ['Install', payment.paymentHookId ? renderDataToken(payment.paymentHookId) : '—'],
      ['Status', payment.confirmedAt
        ? '<span class="badge badge--ok">Confirmed</span>'
        : '<span class="badge badge--warn">Pending</span>'],
      ['Created', payment.createdAt ? new Date(payment.createdAt).toLocaleString() : '—'],
      [
        'API',
        '<button class="btn btn--ghost btn--sm" type="button" data-api-console-payment="1">Open API console</button>'
      ]
    ]

    card.innerHTML = rows
      .map(([label, value]) => `<div class="hook-detail-card__row"><span class="hook-detail-card__label">${label}</span><span class="hook-detail-card__value">${value}</span></div>`)
      .join('')

    paymentLookupResult.replaceChildren(card)
    card.querySelector('[data-api-console-payment]')?.addEventListener('click', () => {
      openApiConsole(apiConsoleParamsFromPayment(payment))
    })
  } catch (error) {
    setActionButtonState(paymentFetchBtn, 'error')
    setStatus(error.message || 'Payment not found.', 'error', paymentLookupStatus)
  }
}

function setFilterSwitchPressed (groupEl, attr, value) {
  if (!groupEl) return
  groupEl.querySelectorAll('.filter-switch__btn').forEach((btn) => {
    btn.setAttribute('aria-pressed', btn.getAttribute(attr) === value ? 'true' : 'false')
  })
}

function syncListRangeSelects () {
  if (hooksRangeSelect) hooksRangeSelect.value = hooksState.range
  if (paymentsRangeSelect) paymentsRangeSelect.value = paymentsState.range
}

async function applyPaymentsFilters (patch = {}) {
  Object.assign(paymentsState, patch, { page: 1 })
  await loadPayments()
}

async function loadPayments () {
  const { page, range: rangeValue, status } = paymentsState
  const params = new URLSearchParams({ page })
  const range = analyticsRange(rangeValue)
  if (range.value !== 'all') params.set('days', String(range.days))
  if (status) params.set('status', status)

  paymentsStatus.hidden = false
  paymentsStatus.textContent = 'Loading…'
  paymentsStatus.className = 'dashboard-status dashboard-status--loading'
  paymentsTableWrap.replaceChildren()
  paymentsPagination.replaceChildren()

  try {
    const data = await apiRequest(`/dashboard/payments?${params}`)
    paymentsStatus.hidden = true

    const columns = [
      { key: 'id', label: 'ID', render: val => rawHtml(renderDataToken(val)) },
      { key: 'email', label: 'Email' },
      { key: 'productId', label: 'Product', render: val => val ? rawHtml(renderDataToken(val)) : '—' },
      { key: 'priceId', label: 'Price', render: val => val ? rawHtml(renderDataToken(val)) : '—' },
      {
        key: 'confirmedAt',
        label: 'Status',
        render: val => rawHtml(val
          ? '<span class="badge badge--ok">Confirmed</span>'
          : '<span class="badge badge--warn">Pending</span>')
      },
      { key: 'createdAt', label: 'Created', render: val => val ? new Date(val).toLocaleString() : '—' },
      {
        key: 'id',
        label: '',
        render: (_val, row) => rawHtml(
          `<button class="btn btn--ghost btn--sm" type="button" data-api-console-payment="${escapeAttr(row.id)}">API console</button>`
        )
      }
    ]

    paymentsTableWrap.replaceChildren(renderTable(columns, data.items))
    paymentsTableWrap.querySelectorAll('[data-api-console-payment]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.stopPropagation()
        const payment = data.items.find((item) => item.id === btn.getAttribute('data-api-console-payment'))
        if (payment) openApiConsole(apiConsoleParamsFromPayment(payment))
      })
    })
    renderPaginationBar(paymentsPagination, data, (newPage) => {
      paymentsState.page = newPage
      loadPayments()
    })
  } catch (error) {
    paymentsStatus.hidden = false
    paymentsStatus.textContent = error.message || 'Failed to load payments.'
    paymentsStatus.className = 'dashboard-status dashboard-status--error'
  }
}

// Fetch the whole product list once and cache it. Products are paginated by
// Stripe via cursors; we page through them (capped) so the full catalog is
// available client-side for instant rendering on Unlock Page and sales.
function fetchAllProducts () {
  return (async () => {
    const items = []
    let startingAfter = null

    for (let i = 0; i < 25; i++) { // safety cap: 25 × 100 = 2500 products
      const params = new URLSearchParams({ limit: 100 })
      if (startingAfter) params.set('startingAfter', startingAfter)
      const data = await apiRequest(`/dashboard/products?${params}`)
      items.push(...(data.items || []))
      if (!data.hasMore || !data.nextCursor) break
      startingAfter = data.nextCursor
    }

    return items
  })()
}

function loadProductCatalog ({ force = false } = {}) {
  if (force) resetProductCatalog()
  if (productCatalog.loaded) return Promise.resolve(productCatalog.items)

  if (!productCatalog.promise) {
    productCatalog.promise = fetchAllProducts()
      .then((items) => {
        productCatalog.items = items
        productCatalog.loaded = true
        return items
      })
      .finally(() => { productCatalog.promise = null })
  }

  return productCatalog.promise
}

function resetProductCatalog () {
  productCatalog.items = []
  productCatalog.loaded = false
  productCatalog.promise = null
}

function formatSharePercent (share) {
  if (!Number.isFinite(share) || share <= 0) return '0%'
  return `${Math.round(share * 1000) / 10}%`
}

// ─── API console ─────────────────────────────────────────────────────────────

const apiConsoleEndpoint = document.getElementById('api-console-endpoint')
const apiConsoleMethod = document.getElementById('api-console-method')
const apiConsolePath = document.getElementById('api-console-path')
const apiConsoleKey = document.getElementById('api-console-key')
const apiConsoleBody = document.getElementById('api-console-body')
const apiConsoleSendBtn = document.getElementById('api-console-send-btn')
const apiConsoleStatus = document.getElementById('api-console-status')
const apiConsoleResponseMeta = document.getElementById('api-console-response-meta')
const apiConsoleResponseBody = document.getElementById('api-console-response-body')

const API_CONSOLE_ENDPOINTS = {
  'create-hook': {
    method: 'POST',
    path: () => '/v1/payment_hooks',
    body: () => JSON.stringify({}, null, 2)
  },
  pull: {
    method: 'POST',
    path: ({ paymentHookId }) => `/v1/payment_hooks/${encodeURIComponent(paymentHookId || 'hook_id')}/pull`,
    body: () => JSON.stringify({}, null, 2)
  },
  'manage-plan': {
    method: 'POST',
    path: ({ paymentHookId }) => `/v1/payment_hooks/${encodeURIComponent(paymentHookId || 'hook_id')}/manage_plan`,
    body: () => JSON.stringify({ returnUrl: 'https://dashboard.payhook.link/' }, null, 2)
  },
  'create-payment': {
    method: 'POST',
    path: () => '/v1/payments',
    body: ({ paymentHookId, productId, priceId, email }) => JSON.stringify({
      paymentHookId: paymentHookId || 'hook_id',
      productId: productId || 'prod_xxx',
      priceId: priceId || 'price_xxx',
      email: email || 'customer@example.com',
      successUrl: 'https://unlock.payhook.link/success/',
      cancelUrl: 'https://unlock.payhook.link/'
    }, null, 2)
  },
  config: {
    method: 'GET',
    path: () => '/v1/config',
    body: () => ''
  }
}

function apiConsoleParamsFromPayment (payment) {
  return {
    endpoint: 'create-payment',
    paymentId: payment.id || '',
    paymentHookId: payment.paymentHookId || '',
    productId: payment.productId || '',
    priceId: payment.priceId || '',
    email: payment.email || ''
  }
}

function getApiConsoleParamsFromUrl () {
  const params = new URL(window.location.href).searchParams
  return {
    endpoint: params.get('endpoint') || '',
    paymentHookId: params.get('paymentHookId') || params.get('hookId') || '',
    paymentId: params.get('paymentId') || '',
    productId: params.get('productId') || '',
    priceId: params.get('priceId') || '',
    email: params.get('email') || ''
  }
}

function setApiConsoleParamsInUrl (params, { replace = false } = {}) {
  const url = buildSectionUrl('api-console')
  ;['endpoint', 'paymentHookId', 'paymentId', 'productId', 'priceId', 'email'].forEach((key) => {
    url.searchParams.delete(key)
  })
  url.searchParams.delete('hookId')
  Object.entries(params).forEach(([key, value]) => {
    if (value) url.searchParams.set(key, value)
  })
  const state = { section: 'api-console', testMode: getTestMode() }
  if (replace) window.history.replaceState(state, '', url.toString())
  else window.history.pushState(state, '', url.toString())
}

function applyApiConsoleEndpoint (endpointKey, context = {}) {
  const preset = API_CONSOLE_ENDPOINTS[endpointKey] || API_CONSOLE_ENDPOINTS.pull
  if (apiConsoleEndpoint && API_CONSOLE_ENDPOINTS[endpointKey]) {
    apiConsoleEndpoint.value = endpointKey
  }
  if (apiConsoleMethod) apiConsoleMethod.value = preset.method
  if (apiConsolePath) apiConsolePath.value = preset.path(context)
  if (apiConsoleBody) {
    apiConsoleBody.value = preset.body(context)
    apiConsoleBody.disabled = preset.method === 'GET'
  }
}

function openApiConsole (params = {}) {
  const next = {
    endpoint: params.endpoint || 'pull',
    paymentHookId: params.paymentHookId || '',
    paymentId: params.paymentId || '',
    productId: params.productId || '',
    priceId: params.priceId || '',
    email: params.email || ''
  }
  setApiConsoleParamsInUrl(next)
  navigateTo('api-console', { updateUrl: false })
  applyApiConsoleEndpoint(next.endpoint, next)
}

async function loadApiConsoleKeys ({ force = false } = {}) {
  if (!apiConsoleKey) return
  if (apiConsoleKeysLoaded && !force) return

  const previous = apiConsoleKey.value
  apiConsoleKey.innerHTML = '<option value="">Loading keys…</option>'

  try {
    const { items = [] } = await apiRequest('/dashboard/api_keys')
    const keys = items.filter((item) =>
      !item.revokedAt && item.rawKey && Boolean(item.testMode) === getTestMode()
    )
    apiConsoleKeysLoaded = true

    if (!keys.length) {
      apiConsoleKey.innerHTML = '<option value="">No publishable keys — create one under API keys</option>'
      return
    }

    apiConsoleKey.innerHTML = keys.map((item) => {
      const label = item.label ? `${item.rawKey} (${item.label})` : item.rawKey
      return `<option value="${escapeAttr(item.rawKey)}">${escapeHtml(label)}</option>`
    }).join('')

    if (previous && keys.some((item) => item.rawKey === previous)) {
      apiConsoleKey.value = previous
    }
  } catch (error) {
    apiConsoleKeysLoaded = false
    apiConsoleKey.innerHTML = `<option value="">${escapeHtml(error.message || 'Failed to load keys')}</option>`
  }
}

async function prepareApiConsole () {
  await loadApiConsoleKeys()
  const params = getApiConsoleParamsFromUrl()
  const endpoint = API_CONSOLE_ENDPOINTS[params.endpoint] ? params.endpoint : (apiConsoleEndpoint?.value || 'create-hook')
  applyApiConsoleEndpoint(endpoint, params)
}

async function sendApiConsoleRequest () {
  if (!apiConsoleSendBtn) return

  const method = (apiConsoleMethod?.value || 'GET').toUpperCase()
  const path = (apiConsolePath?.value || '').trim()
  const apiKey = apiConsoleKey?.value || ''
  const rawBody = apiConsoleBody?.value?.trim() || ''

  if (!path.startsWith('/')) {
    setStatus('Path must start with /', 'error', apiConsoleStatus)
    return
  }
  if (!apiKey) {
    setStatus('Select a publishable API key first.', 'error', apiConsoleStatus)
    return
  }

  let body
  if (method !== 'GET' && rawBody) {
    try {
      body = JSON.stringify(JSON.parse(rawBody))
    } catch {
      setStatus('Request body must be valid JSON.', 'error', apiConsoleStatus)
      return
    }
  }

  setActionButtonState(apiConsoleSendBtn, 'loading', { loadingLabel: 'Sending…' })
  setStatus('Sending…', 'loading', apiConsoleStatus)
  if (apiConsoleResponseMeta) apiConsoleResponseMeta.hidden = true

  const started = performance.now()
  try {
    const headers = {
      Authorization: `Bearer ${apiKey}`,
      ...(body !== undefined ? { 'Content-Type': 'application/json' } : {})
    }
    const response = await window.fetch(`${API_URL}${path}`, {
      method,
      headers,
      body: body !== undefined ? body : undefined
    })
    const elapsedMs = Math.round(performance.now() - started)
    const text = await response.text()
    let pretty = text
    try {
      pretty = JSON.stringify(JSON.parse(text), null, 2)
    } catch {}

    if (apiConsoleResponseBody) apiConsoleResponseBody.textContent = pretty || '(empty body)'
    if (apiConsoleResponseMeta) {
      apiConsoleResponseMeta.hidden = false
      apiConsoleResponseMeta.textContent = `${response.status} ${response.statusText || ''} · ${elapsedMs} ms`.trim()
      apiConsoleResponseMeta.className = `api-console__response-meta ${response.ok ? 'is-ok' : 'is-error'}`
    }

    setActionButtonState(apiConsoleSendBtn, response.ok ? 'success' : 'error', {
      successLabel: 'Sent'
    })
    setStatus(
      response.ok ? 'Request completed.' : `Request failed (${response.status}).`,
      response.ok ? 'success' : 'error',
      apiConsoleStatus
    )
  } catch (error) {
    if (apiConsoleResponseBody) apiConsoleResponseBody.textContent = error.message || String(error)
    if (apiConsoleResponseMeta) {
      apiConsoleResponseMeta.hidden = false
      apiConsoleResponseMeta.textContent = 'Network error'
      apiConsoleResponseMeta.className = 'api-console__response-meta is-error'
    }
    setActionButtonState(apiConsoleSendBtn, 'error')
    setStatus(error.message || 'Request failed.', 'error', apiConsoleStatus)
  }
}

if (apiConsoleEndpoint) {
  apiConsoleEndpoint.addEventListener('change', () => {
    const params = getApiConsoleParamsFromUrl()
    applyApiConsoleEndpoint(apiConsoleEndpoint.value, params)
    setApiConsoleParamsInUrl({ ...params, endpoint: apiConsoleEndpoint.value }, { replace: true })
  })
}

if (apiConsoleMethod) {
  apiConsoleMethod.addEventListener('change', () => {
    if (apiConsoleBody) apiConsoleBody.disabled = apiConsoleMethod.value === 'GET'
  })
}

if (apiConsoleSendBtn) {
  apiConsoleSendBtn.addEventListener('click', () => { void sendApiConsoleRequest() })
}

// ─── API keys ────────────────────────────────────────────────────────────────

const apiKeysStatus = document.getElementById('api-keys-status')
const apiKeysTableWrap = document.getElementById('api-keys-table-wrap')
const apiKeysNewBtn = document.getElementById('api-keys-new-btn')
const apiKeysCreateForm = document.getElementById('api-keys-create-form')
const apiKeysCancelBtn = document.getElementById('api-keys-cancel-btn')
const apiKeysCreateBtn = document.getElementById('api-keys-create-btn')
const apiKeysReveal = document.getElementById('api-keys-reveal')
const apiKeysRevealValue = document.getElementById('api-keys-reveal-value')
const apiKeysRevealCopy = document.getElementById('api-keys-reveal-copy')
const apiKeysRevealDismiss = document.getElementById('api-keys-reveal-dismiss')
const apiKeyLabelInput = document.getElementById('api-key-label')

function showApiKeysForm (visible) {
  apiKeysCreateForm.hidden = !visible
  apiKeysNewBtn.hidden = visible
  if (visible) {
    apiKeysReveal.hidden = true
    apiKeyLabelInput.value = ''
    apiKeyLabelInput.focus()
  }
}

function formatApiKeyDate (value) {
  if (!value) return '—'
  try {
    return new Date(value).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  } catch {
    return '—'
  }
}

function renderApiKeyCell (rawKey, keyId) {
  if (rawKey) {
    return rawHtml(
      '<span class="api-key-cell">' +
      `<span class="data-token data-token--key">${escapeHtml(rawKey)}</span>` +
      `<button class="btn btn--ghost btn--sm" type="button" data-copy-key="${escapeAttr(rawKey)}">Copy</button>` +
      '</span>'
    )
  }
  const truncated = keyId ? `${keyId}…` : '—'
  return rawHtml(`<span class="data-token data-token--key">${escapeHtml(truncated)}</span>`)
}

async function loadApiKeys () {
  apiKeysStatus.hidden = false
  apiKeysStatus.textContent = 'Loading…'
  apiKeysStatus.className = 'dashboard-status dashboard-status--loading'
  apiKeysTableWrap.replaceChildren()

  try {
    const { items = [] } = await apiRequest('/dashboard/api_keys')
    const filtered = items.filter((item) => Boolean(item.testMode) === getTestMode())
    apiKeysStatus.hidden = true

    const columns = [
      {
        key: 'rawKey',
        label: 'Key',
        render: (val, row) => renderApiKeyCell(val, row.keyId)
      },
      { key: 'label', label: 'Label', render: val => val || '—' },
      {
        key: 'createdAt',
        label: 'Created',
        render: val => formatApiKeyDate(val)
      },
      {
        key: 'lastUsedAt',
        label: 'Last used',
        render: val => formatApiKeyDate(val)
      },
      {
        key: 'revokedAt',
        label: '',
        render: (val, row) => {
          if (val) return rawHtml('<span class="badge badge--error">Revoked</span>')
          const params = new URLSearchParams({ testMode: row.testMode ? 'true' : 'false' })
          return rawHtml(`<button class="btn btn--ghost btn--sm btn--danger" type="button" data-revoke-key="${escapeAttr(row.keyHash)}" data-revoke-params="${escapeAttr(params)}">Revoke</button>`)
        }
      }
    ]

    apiKeysTableWrap.replaceChildren(renderTable(columns, filtered, {
      emptyMessage: getTestMode()
        ? 'No test API keys yet.'
        : 'No live API keys yet.'
    }))

    apiKeysTableWrap.querySelectorAll('[data-revoke-key]').forEach(btn => {
      btn.addEventListener('click', () => revokeApiKey(btn))
    })
    apiKeysTableWrap.querySelectorAll('[data-copy-key]').forEach(btn => {
      btn.addEventListener('click', () => copyText(btn.dataset.copyKey, btn))
    })
  } catch (error) {
    apiKeysStatus.hidden = false
    apiKeysStatus.textContent = error.message || 'Failed to load API keys.'
    apiKeysStatus.className = 'dashboard-status dashboard-status--error'
  }
}

async function createApiKey (event) {
  event.preventDefault()
  setActionButtonState(apiKeysCreateBtn, 'loading', { loadingLabel: 'Creating…' })
  setStatus('', 'idle', apiKeysStatus)

  const testMode = getTestMode()
  const label = apiKeyLabelInput.value.trim() || null

  try {
    const result = await apiRequest('/dashboard/api_keys', {
      method: 'POST',
      body: JSON.stringify({ testMode, label })
    })

    apiKeysRevealValue.textContent = result.rawKey
    apiKeysReveal.hidden = false
    showApiKeysForm(false)
    setActionButtonState(apiKeysCreateBtn, 'success', { successLabel: 'Created' })
    apiConsoleKeysLoaded = false
    loadApiKeys()
  } catch (error) {
    setActionButtonState(apiKeysCreateBtn, 'error')
    setStatus(error.message || 'Failed to create key.', 'error', apiKeysStatus)
  }
}

async function revokeApiKey (btn) {
  if (!window.confirm('Revoke this API key? Clients using it will start receiving 401 immediately.')) return
  const keyHash = btn.dataset.revokeKey
  const params = btn.dataset.revokeParams
  setActionButtonState(btn, 'loading', { loadingLabel: 'Revoking…' })
  try {
    await apiRequest(`/dashboard/api_keys/${keyHash}?${params}`, { method: 'DELETE' })
    apiConsoleKeysLoaded = false
    await loadApiKeys()
    setActionButtonState(btn, 'idle')
  } catch (error) {
    setActionButtonState(btn, 'error')
    setStatus(error.message || 'Failed to revoke key.', 'error', apiKeysStatus)
  }
}

if (apiKeysNewBtn) apiKeysNewBtn.addEventListener('click', () => showApiKeysForm(true))
if (apiKeysCancelBtn) apiKeysCancelBtn.addEventListener('click', () => showApiKeysForm(false))
if (apiKeysCreateForm) apiKeysCreateForm.addEventListener('submit', createApiKey)
if (apiKeysRevealCopy) apiKeysRevealCopy.addEventListener('click', () => copyText(apiKeysRevealValue.textContent, apiKeysRevealCopy))
if (apiKeysRevealDismiss) {
  apiKeysRevealDismiss.addEventListener('click', () => {
    apiKeysReveal.hidden = true
    apiKeysRevealValue.textContent = ''
  })
}

async function bootstrap () {
  initSiteHeader()
  syncTestModeFromUrl()
  updateModeToggle()

  const oauthCode = getOAuthCodeFromUrl()
  const authError = getAuthErrorFromUrl()
  if (authError) stripAuthErrorFromUrl()

  try {
    await loadBootstrap()
  } catch (error) {
    currentUser = null
    currentAccount = null
    workspaces = []
    currentWorkspaceId = null
    clearStoredAccountId()
    if (oauthCode) stripOAuthParamsFromUrl()
    if (await needsStorageAccess()) {
      showStorageAccessPanel()
      return
    }
    showAuthView({
      message: authError ||
        (oauthCode
          ? 'Sign in before connecting Stripe, then start setup again.'
          : '')
    })
    return
  }

  if (oauthCode) {
    try {
      await exchangeOAuthCode(oauthCode)
      await loadDashboard()
    } catch (error) {
      showConnectView({ message: error.message || 'Failed to connect Stripe account.' })
    }
    return
  }

  await loadDashboard()
}

headerDisconnectBtn.addEventListener('click', async () => {
  headerDisconnectBtn.disabled = true
  await apiRequest('/auth/signout', {
    method: 'POST',
    live: true,
    retryAuth: false
  }).catch(() => {})

  currentUser = null
  currentAccount = null
  workspaces = []
  currentWorkspaceId = null
  setStoredWorkspaceId(null)
  clearStoredAccountId()
  clearStoredAuthEmail()
  if (modeToggle) modeToggle.hidden = true
  updateModeToggle()
  setStatus('')
  showAuthView()
  headerDisconnectBtn.disabled = false
})

if (authForm) {
  authForm.addEventListener('submit', async (event) => {
    event.preventDefault()
    setConnectStatus('')

    const email = authEmailInput.value.trim().toLowerCase()
    setAuthBusy(true)

    try {
      await requestMagicLink(email)
    } catch (error) {
      setConnectStatus(error.message || 'Could not send sign-in link. Try again.', 'error')
      setAuthBusy(false)
    }
  })
}

if (authResendBtn) {
  authResendBtn.addEventListener('click', async () => {
    const email = pendingAuthEmail || authEmailInput.value.trim().toLowerCase()
    if (!email) {
      showAuthFormPanel()
      return
    }

    setAuthBusy(true)
    setConnectStatus('Sending another link…', 'loading')
    try {
      await requestMagicLink(email)
    } catch (error) {
      setConnectStatus(error.message || 'Could not send sign-in link. Try again.', 'error')
      setAuthBusy(false)
    }
  })
}

createHookBtn.addEventListener('click', createPaymentHook)

if (dashboardLoadingRetry) {
  dashboardLoadingRetry.addEventListener('click', loadDashboard)
}

document.querySelectorAll('.dash-sidebar__item').forEach(btn => {
  btn.addEventListener('click', () => {
    navigateTo(btn.dataset.section)
    closeMobileNav()
  })
})

const appRailBackdrop = document.getElementById('app-rail-backdrop')
const mobileMenuBtn = document.getElementById('mobile-menu-btn')
const mobileCloseBtn = document.getElementById('mobile-close-btn')
const mobileNavQuery = window.matchMedia('(max-width: 900px)')

function openMobileNav () {
  appRail.classList.add('is-open')
  appRailBackdrop.hidden = false
  requestAnimationFrame(() => appRailBackdrop.classList.add('is-visible'))
  document.body.classList.add('nav-open')
  mobileMenuBtn.setAttribute('aria-expanded', 'true')
}

function closeMobileNav () {
  appRail.classList.remove('is-open')
  appRailBackdrop.classList.remove('is-visible')
  appRailBackdrop.hidden = true
  document.body.classList.remove('nav-open')
  mobileMenuBtn.setAttribute('aria-expanded', 'false')
}

mobileMenuBtn.addEventListener('click', () => {
  if (appRail.classList.contains('is-open')) closeMobileNav()
  else openMobileNav()
})

mobileCloseBtn.addEventListener('click', closeMobileNav)
appRailBackdrop.addEventListener('click', closeMobileNav)

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeMobileNav()
})

mobileNavQuery.addEventListener('change', (e) => {
  if (!e.matches) closeMobileNav()
})

if (modeLiveBtn) modeLiveBtn.addEventListener('click', () => { if (getTestMode()) setMode(false) })
if (modeTestBtn) modeTestBtn.addEventListener('click', () => { if (!getTestMode()) setMode(true) })

if (hooksRangeSelect) {
  hooksRangeSelect.addEventListener('change', () => {
    hooksState.range = hooksRangeSelect.value
    hooksState.page = 1
    loadPaymentHooks()
  })
}

if (paymentsRangeSelect) {
  paymentsRangeSelect.addEventListener('change', () => {
    applyPaymentsFilters({ range: paymentsRangeSelect.value })
  })
}

function toggleHookLookup () {
  if (!hookLookupBlock || !hookLookupToggleBtn) return

  const open = hookLookupBlock.hidden
  hookLookupBlock.hidden = !open
  hookLookupToggleBtn.setAttribute('aria-expanded', String(open))

  if (open) {
    void maybePrefillHookIdFromSlowedExtension().finally(() => {
      hookIdInput.focus()
    })
  }
}

function togglePaymentLookup () {
  if (!paymentLookupBlock || !paymentLookupToggleBtn) return

  const open = paymentLookupBlock.hidden
  paymentLookupBlock.hidden = !open
  paymentLookupToggleBtn.setAttribute('aria-expanded', String(open))

  if (open) {
    paymentIdInput.focus()
  }
}

hookLookupToggleBtn.addEventListener('click', toggleHookLookup)
paymentLookupToggleBtn.addEventListener('click', togglePaymentLookup)

hookFetchBtn.addEventListener('click', fetchPaymentHook)
paymentFetchBtn.addEventListener('click', fetchPayment)

hookIdInput.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') hookFetchBtn.click()
})

paymentIdInput.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') paymentFetchBtn.click()
})

const requestDetailModal = document.getElementById('request-detail-modal')
const requestDetailModalClose = document.getElementById('request-detail-modal-close')
if (requestDetailModalClose) {
  requestDetailModalClose.addEventListener('click', closeAccessRequestDetail)
}
if (requestDetailModal) {
  requestDetailModal.addEventListener('click', (event) => {
    if (event.target.id === 'request-detail-modal') closeAccessRequestDetail()
  })
}

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return
  closeAccessRequestDetail()
})

if (paymentsStatusFilter) {
  paymentsStatusFilter.addEventListener('click', (event) => {
    const btn = event.target.closest('.filter-switch__btn')
    if (!btn || !paymentsStatusFilter.contains(btn)) return
    const status = btn.dataset.status || ''
    if (status === paymentsState.status) return
    setFilterSwitchPressed(paymentsStatusFilter, 'data-status', status)
    applyPaymentsFilters({ status })
  })
}

if (overviewRangeSelect) {
  overviewRangeSelect.value = analyticsWindow
  overviewRangeSelect.addEventListener('change', (e) => {
    setAnalyticsWindow(e.target.value)
  })
}
if (analyticsRangeSelect) {
  analyticsRangeSelect.value = analyticsWindow
  analyticsRangeSelect.addEventListener('change', (e) => {
    setAnalyticsWindow(e.target.value)
  })
}
if (salesRangeSelect) {
  salesRangeSelect.value = analyticsWindow
  salesRangeSelect.addEventListener('change', (e) => {
    setAnalyticsWindow(e.target.value)
  })
}

// Primary color and logo are shared across the editable dashboard previews.
// The hosted unlock preview reflects published settings and refreshes after save.
function refreshBrandingDependentPreviews () {
  renderEmailPreview()
  if (buttonSectionReady) refreshButtonPreview()
}

if (brandingForm) brandingForm.addEventListener('submit', saveBranding)
if (brandingPrimaryColor) {
  brandingPrimaryColor.addEventListener('input', () => {
    brandingPrimaryColorText.value = brandingPrimaryColor.value
    refreshBrandingDependentPreviews()
  })
}
if (brandingPrimaryColorText) {
  brandingPrimaryColorText.addEventListener('input', refreshBrandingDependentPreviews)
}
if (brandingLogoUrl) brandingLogoUrl.addEventListener('input', refreshBrandingDependentPreviews)

if (copyWebsiteSetupBtn) {
  copyWebsiteSetupBtn.addEventListener('click', () => {
    copyText(buildWebsiteSetupBrief(), copyWebsiteSetupBtn)
  })
}

if (copyExtensionSetupBtn) {
  copyExtensionSetupBtn.addEventListener('click', () => {
    copyText(buildExtensionSetupBrief(), copyExtensionSetupBtn)
  })
}

window.addEventListener('popstate', (e) => {
  const section = (e.state && e.state.section) || getSectionFromUrl() || 'overview'
  const catalogTab = section === 'product-catalog'
    ? (e.state?.tab || getCatalogTabFromUrl())
    : null
  const sectionChanged = SECTIONS.includes(section) && section !== activeSection
  const catalogTabChanged = section === 'product-catalog' && catalogTab && catalogTab !== getActiveCatalogTab()

  if (sectionChanged || catalogTabChanged) {
    navigateTo(section, { updateUrl: false })
  }
  if (section === 'product-catalog' && catalogTab) {
    activateCatalogTab(catalogTab)
    showProductCatalogPreview()
  }

  const testMode = e.state?.testMode ?? getTestModeFromUrl() ?? getTestMode()
  applyTestMode(testMode)
})

// ─── Experiments ─────────────────────────────────────────────────────────────
// Pricing A/B tests on the hosted unlock page. The `experiments` list lives on
// unlock settings (PUT replaces the whole list; the API validates and guards
// running experiments against bucket shrinks and repricing). Funnel numbers
// come from /dashboard/experiments/{id}/stats.

const experimentsStatus = document.getElementById('experiments-status')
const experimentsListEl = document.getElementById('experiments-list')
const experimentsEditor = document.getElementById('experiments-editor')
const experimentsJsonInput = document.getElementById('experiments-json')
const experimentsEditorStatus = document.getElementById('experiments-editor-status')
const experimentsNewBtn = document.getElementById('experiments-new-btn')
const experimentsEditorCancelBtn = document.getElementById('experiments-editor-cancel')

let currentExperiments = []

const EXPERIMENT_TEMPLATE = {
  id: 'price-test-1',
  status: 'draft',
  minVersion: '',
  variants: [
    { name: 'control', bucket: [0, 50], priceIds: ['price_REPLACE_ME'] },
    { name: 'treatment', bucket: [50, 100], priceIds: ['price_REPLACE_ME'] }
  ]
}

function setExperimentsStatus (state, message) {
  if (!experimentsStatus) return
  if (!state) {
    experimentsStatus.hidden = true
    return
  }
  experimentsStatus.hidden = false
  experimentsStatus.textContent = message
  experimentsStatus.className = `dashboard-status dashboard-status--${state}`
}

async function loadExperiments () {
  if (!experimentsListEl) {
    experimentsLoaded = false
    setExperimentsStatus('error', 'Experiments UI failed to load. Hard-refresh the page.')
    return
  }

  setExperimentsStatus('loading', 'Loading…')
  experimentsListEl.replaceChildren()

  try {
    const data = await apiRequest('/dashboard/unlock_settings')
    currentExperiments = Array.isArray(data.experiments) ? data.experiments : []
    setExperimentsStatus(null)
    renderExperiments()
  } catch (error) {
    experimentsLoaded = false
    setExperimentsStatus('error', error.message || 'Failed to load experiments.')
  }
}

function renderExperiments () {
  if (!experimentsListEl) return
  experimentsListEl.replaceChildren()

  if (currentExperiments.length === 0) {
    const p = document.createElement('p')
    p.className = 'data-table__empty'
    p.textContent = 'No experiments yet. "New experiment" starts a draft — dedicated Stripe prices per variant, same products and currencies as the plans they replace.'
    experimentsListEl.appendChild(p)
    return
  }

  currentExperiments.forEach((experiment) => {
    if (!experiment || !experiment.id) return
    experimentsListEl.appendChild(renderExperimentCard(experiment))
  })
}

function experimentStatusBadge (status) {
  if (status === 'running') return '<span class="badge badge--ok">Running</span>'
  if (status === 'stopped') return '<span class="badge badge--error">Stopped</span>'
  return '<span class="badge badge--warn">Draft</span>'
}

function formatBucket (bucket) {
  if (!Array.isArray(bucket) || bucket.length !== 2) return '—'
  return `${bucket[0]}–${bucket[1] - 1} (${bucket[1] - bucket[0]}%)`
}

function formatRevenueByCurrency (revenue) {
  const entries = Object.entries(revenue || {}).filter(([, amount]) => amount > 0)
  if (entries.length === 0) return '—'
  return entries.map(([currency, amount]) => {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency.toUpperCase() }).format(amount / 100)
    } catch (_) {
      return `${currency.toUpperCase()} ${(amount / 100).toFixed(2)}`
    }
  }).join(' · ')
}

function formatRate (rate) {
  if (rate === null || rate === undefined) return '—'
  return `${(rate * 100).toFixed(2)}%`
}

function formatPValue (pValue) {
  if (pValue === null || pValue === undefined) return '—'
  const label = pValue < 0.001 ? '<0.001' : pValue.toFixed(3)
  if (pValue < 0.05) return rawHtml(`<span class="badge badge--ok" title="p-value vs control (view→paid)">${label}</span>`)
  return rawHtml(`<span title="p-value vs control (view→paid) — not significant yet">${label}</span>`)
}

function renderExperimentCard (experiment) {
  const card = document.createElement('section')
  card.className = 'experiment-card'

  const startedAt = experiment.startedAt
    ? new Date(experiment.startedAt).toLocaleDateString()
    : null
  const metaParts = [
    experiment.minVersion ? `≥ v${escapeHtml(experiment.minVersion)}` : 'all versions',
    startedAt ? `started ${escapeHtml(startedAt)}` : null
  ].filter(Boolean)

  const head = document.createElement('div')
  head.className = 'experiment-card__head'
  head.innerHTML = `
    <div class="experiment-card__title">
      <h3><code>${escapeHtml(experiment.id)}</code></h3>
      ${experimentStatusBadge(experiment.status)}
      <span class="experiment-card__meta">${metaParts.join(' · ')}</span>
    </div>
    <div class="experiment-card__actions">
      ${experiment.status === 'running'
        ? `<button class="btn btn--ghost btn--sm btn--danger" type="button" data-exp-stop="${escapeAttr(experiment.id)}">Stop</button>`
        : `<button class="btn btn--primary btn--sm" type="button" data-exp-run="${escapeAttr(experiment.id)}">Run</button>`}
      <button class="btn btn--ghost btn--sm" type="button" data-exp-edit="${escapeAttr(experiment.id)}">Edit JSON</button>
    </div>
  `

  const tableWrap = document.createElement('div')
  tableWrap.className = 'data-table-wrap'
  tableWrap.innerHTML = '<p class="data-table__empty">Loading funnel…</p>'

  card.appendChild(head)
  card.appendChild(tableWrap)

  head.querySelector('[data-exp-stop]')?.addEventListener('click', () => setExperimentStatus(experiment.id, 'stopped'))
  head.querySelector('[data-exp-run]')?.addEventListener('click', () => setExperimentStatus(experiment.id, 'running'))
  head.querySelector('[data-exp-edit]')?.addEventListener('click', () => openExperimentsEditor())

  renderExperimentFunnel(experiment, tableWrap)
  return card
}

async function renderExperimentFunnel (experiment, tableWrap) {
  let stats = null
  try {
    stats = await apiRequest(`/dashboard/experiments/${encodeURIComponent(experiment.id)}/stats`)
  } catch (error) {
    tableWrap.innerHTML = ''
    const p = document.createElement('p')
    p.className = 'data-table__empty'
    p.textContent = `Funnel unavailable: ${error.message || 'request failed'}`
    tableWrap.appendChild(p)
    return
  }

  const columns = [
    {
      key: 'name',
      label: 'Variant',
      render: (val, row) => rawHtml(`<strong>${escapeHtml(val)}</strong>${row.name === stats.control ? ' <span class="country-code">(control)</span>' : ''}`)
    },
    { key: 'bucket', label: 'Bucket', render: formatBucket },
    { key: 'views', label: 'Views' },
    { key: 'checkouts', label: 'Checkouts' },
    { key: 'paid', label: 'Paid' },
    { key: 'viewToCheckout', label: 'View→Checkout', render: formatRate },
    { key: 'viewToPaid', label: 'View→Paid', render: formatRate },
    { key: 'revenueByCurrency', label: 'Revenue', render: formatRevenueByCurrency },
    { key: 'pValueVsControl', label: 'p vs control', render: formatPValue }
  ]

  tableWrap.replaceChildren(renderTable(columns, stats.variants || [], {
    emptyMessage: 'No variants.'
  }))

  const note = document.createElement('p')
  note.className = 'experiment-card__note'
  note.textContent = `Last ${stats.days} day${stats.days === 1 ? '' : 's'}. Decide on revenue per view — a cheaper arm almost always wins raw conversion.`
  tableWrap.appendChild(note)
}

async function setExperimentStatus (experimentId, status) {
  const next = currentExperiments.map((experiment) => (
    experiment.id === experimentId ? { ...experiment, status } : experiment
  ))

  setExperimentsStatus('loading', status === 'running' ? 'Starting…' : 'Stopping…')
  try {
    const data = await apiRequest('/dashboard/unlock_settings', {
      method: 'PUT',
      body: JSON.stringify({ experiments: next })
    })
    currentExperiments = Array.isArray(data.experiments) ? data.experiments : []
    setExperimentsStatus(null)
    renderExperiments()
  } catch (error) {
    setExperimentsStatus('error', error.message || 'Failed to update experiment.')
  }
}

function openExperimentsEditor ({ withTemplate = false } = {}) {
  if (!experimentsEditor || !experimentsJsonInput) return
  const draft = withTemplate
    ? [...currentExperiments, EXPERIMENT_TEMPLATE]
    : currentExperiments
  experimentsJsonInput.value = JSON.stringify(draft.length ? draft : [EXPERIMENT_TEMPLATE], null, 2)
  if (experimentsEditorStatus) experimentsEditorStatus.hidden = true
  experimentsEditor.hidden = false
  experimentsJsonInput.focus()
}

function closeExperimentsEditor () {
  if (experimentsEditor) experimentsEditor.hidden = true
}

async function saveExperimentsFromEditor (event) {
  event.preventDefault()
  if (!experimentsJsonInput) return

  let experiments
  try {
    experiments = JSON.parse(experimentsJsonInput.value)
  } catch (_) {
    if (experimentsEditorStatus) {
      experimentsEditorStatus.hidden = false
      experimentsEditorStatus.textContent = 'Invalid JSON.'
      experimentsEditorStatus.className = 'dashboard-status dashboard-status--error'
    }
    return
  }

  if (experimentsEditorStatus) {
    experimentsEditorStatus.hidden = false
    experimentsEditorStatus.textContent = 'Saving…'
    experimentsEditorStatus.className = 'dashboard-status dashboard-status--loading'
  }

  try {
    const data = await apiRequest('/dashboard/unlock_settings', {
      method: 'PUT',
      body: JSON.stringify({ experiments })
    })
    currentExperiments = Array.isArray(data.experiments) ? data.experiments : []
    closeExperimentsEditor()
    renderExperiments()
  } catch (error) {
    if (experimentsEditorStatus) {
      experimentsEditorStatus.textContent = error.message || 'Failed to save experiments.'
      experimentsEditorStatus.className = 'dashboard-status dashboard-status--error'
    }
  }
}

if (experimentsNewBtn) {
  experimentsNewBtn.addEventListener('click', () => openExperimentsEditor({ withTemplate: currentExperiments.length > 0 }))
}
if (experimentsEditorCancelBtn) {
  experimentsEditorCancelBtn.addEventListener('click', closeExperimentsEditor)
}
if (experimentsEditor) {
  experimentsEditor.addEventListener('submit', saveExperimentsFromEditor)
}

// ─── Unlock page / product catalog ───────────────────────────────────────────

const unlockStatusEl = document.getElementById('unlock-status')
const unlockForm = document.getElementById('unlock-settings-form')
const unlockCatalogForm = document.getElementById('unlock-catalog-form')
const unlockCatalogStatusEl = document.getElementById('unlock-catalog-status')
const unlockCatalogSaveBtn = document.getElementById('unlock-catalog-save-btn')
const unlockFeaturesForm = document.getElementById('unlock-features-form')
const unlockFeaturesStatusEl = document.getElementById('unlock-features-status')
const unlockFeaturesSaveBtn = document.getElementById('unlock-features-save-btn')
const trialUsageForm = document.getElementById('trial-usage-form')
const featureUsageEnabled = document.getElementById('feature-usage-enabled')
const featureUsageCaps = document.getElementById('feature-usage-caps')
const featureUsageWeekly = document.getElementById('feature-usage-weekly')
const featureUsageMonthly = document.getElementById('feature-usage-monthly')
const trialDaysInput = document.getElementById('trial-days')
const trialAutoStartInput = document.getElementById('trial-auto-start')
const trialUsageStatusEl = document.getElementById('trial-usage-status')
const trialUsageSaveBtn = document.getElementById('trial-usage-save-btn')
const unlockExtensionName = document.getElementById('unlock-extension-name')
const unlockTagline = document.getElementById('unlock-tagline')
const unlockFooterNote = document.getElementById('unlock-footer-note')
const unlockFeaturesList = document.getElementById('unlock-features-list')
const unlockFeaturesAdd = document.getElementById('unlock-features-add')
const unlockChannelsList = document.getElementById('unlock-channels-list')
const unlockChannelsAdd = document.getElementById('unlock-channels-add')
const unlockSaveBtn = document.getElementById('unlock-save-btn')
const unlockSuccessSaveBtn = document.getElementById('unlock-success-save-btn')

function setUnlockStatus (message, type = 'loading') {
  setStatus(message, type, unlockStatusEl)
  if (unlockCatalogStatusEl) setStatus(message, type, unlockCatalogStatusEl)
  if (unlockFeaturesStatusEl) setStatus(message, type, unlockFeaturesStatusEl)
  if (trialUsageStatusEl) setStatus(message, type, trialUsageStatusEl)
}

function unlockStatusForForm (form) {
  const fromForm = form && form.querySelector('.form-action-status')
  return fromForm || unlockStatusEl
}

function unlockSaveBtnForForm (form) {
  if (form === unlockCatalogForm) return unlockCatalogSaveBtn
  if (form === unlockFeaturesForm) return unlockFeaturesSaveBtn
  if (form === trialUsageForm) return trialUsageSaveBtn
  if (form && form.id === 'unlock-success-form') return unlockSuccessSaveBtn
  return unlockSaveBtn
}

function renderFeatureRow ({ label = '', included = false } = {}) {
  const row = document.createElement('div')
  row.className = 'unlock-features-row'
  row.innerHTML = `
    <input type="text" class="filter-input unlock-feature-label" value="${escapeAttr(label)}" placeholder="Feature label">
    <label class="unlock-features-row__included">
      <input type="checkbox" class="unlock-feature-included" ${included ? 'checked' : ''}>
      Included (free)
    </label>
    <button type="button" class="unlock-row__remove" aria-label="Remove feature">×</button>
  `
  row.querySelector('.unlock-row__remove').addEventListener('click', () => row.remove())
  return row
}

function applyFeatureUsageSettings (featureUsage) {
  if (!featureUsageEnabled || !featureUsageWeekly || !featureUsageMonthly) return
  const normalized = normalizeDashboardFeatureUsage(featureUsage)
  featureUsageEnabled.checked = normalized.enabled
  if (normalized.weekly == null && normalized.monthly == null) {
    featureUsageWeekly.value = '100'
    featureUsageMonthly.value = '300'
  } else {
    featureUsageWeekly.value = normalized.weekly == null ? '' : String(normalized.weekly)
    featureUsageMonthly.value = normalized.monthly == null ? '' : String(normalized.monthly)
  }
  refreshFeatureUsageEditor()
}

function applyTrialSettings (trial) {
  if (!trialDaysInput || !trialAutoStartInput) return
  const normalized = normalizeDashboardTrial(trial)
  trialDaysInput.value = String(normalized.days)
  trialAutoStartInput.checked = normalized.autoStart
  refreshTrialSettingsEditor()
}

function readTrialSettings () {
  return serializeDashboardTrial({
    days: trialDaysInput?.value,
    autoStart: trialAutoStartInput?.checked === true
  })
}

function refreshTrialSettingsEditor () {
  if (!trialAutoStartInput || !trialDaysInput) return
  const days = Number.parseInt(trialDaysInput.value, 10)
  const enabled = Number.isFinite(days) && days > 0
  trialAutoStartInput.disabled = !enabled
  if (!enabled) trialAutoStartInput.checked = false
}

function readFeatureUsageSettings () {
  return serializeDashboardFeatureUsage({
    enabled: featureUsageEnabled?.checked === true,
    weekly: featureUsageWeekly?.value,
    monthly: featureUsageMonthly?.value
  })
}

function renderChannelRow ({ name = '', minVersion = '', priceIds = [] } = {}) {
  const row = document.createElement('div')
  row.className = 'unlock-channels-row'
  row.innerHTML = `
    <div class="unlock-channels-row__meta">
      <label class="unlock-channels-row__field">
        <span class="unlock-channels-row__label">Channel</span>
        <input type="text" class="filter-input unlock-channel-name" value="${escapeAttr(name)}" placeholder="default" autocomplete="off">
      </label>
      <label class="unlock-channels-row__field unlock-channels-row__field--version">
        <span class="unlock-channels-row__label">Min version</span>
        <input type="text" class="filter-input unlock-channel-min" value="${escapeAttr(minVersion)}" placeholder="0.10.0" autocomplete="off" spellcheck="false">
      </label>
      <button type="button" class="unlock-row__remove" aria-label="Remove channel">×</button>
    </div>
    <div class="unlock-channels-row__prices">
      <span class="unlock-channels-row__label">Prices</span>
      <div class="unlock-price-chips" data-price-ids="${escapeAttr(JSON.stringify(priceIds))}"></div>
      <div class="unlock-price-picker">
        <select class="filter-input unlock-price-product" aria-label="Product">
          <option value="">Select product…</option>
        </select>
        <select class="filter-input unlock-price-price" aria-label="Price" disabled>
          <option value="">Select price…</option>
        </select>
        <button type="button" class="btn btn--ghost btn--sm unlock-price-add" disabled>Add</button>
      </div>
      <p class="unlock-channels-row__empty unlock-price-empty" hidden>No prices selected yet.</p>
    </div>
  `

  row.querySelector('.unlock-row__remove').addEventListener('click', () => row.remove())

  const productSelect = row.querySelector('.unlock-price-product')
  const priceSelect = row.querySelector('.unlock-price-price')
  const addBtn = row.querySelector('.unlock-price-add')
  const chipsEl = row.querySelector('.unlock-price-chips')

  productSelect.addEventListener('change', () => {
    fillChannelPriceOptions(row, productSelect.value)
  })

  priceSelect.addEventListener('change', () => {
    addBtn.disabled = !priceSelect.value
  })

  addBtn.addEventListener('click', () => {
    const priceId = priceSelect.value
    if (!priceId) return
    const selected = readChannelPriceIds(row)
    if (selected.includes(priceId)) return
    writeChannelPriceIds(row, [...selected, priceId])
    renderChannelPriceChips(row)
    priceSelect.value = ''
    addBtn.disabled = true
  })

  chipsEl.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-remove-price]')
    if (!btn) return
    const priceId = btn.getAttribute('data-remove-price')
    writeChannelPriceIds(row, readChannelPriceIds(row).filter((id) => id !== priceId))
    renderChannelPriceChips(row)
    fillChannelPriceOptions(row, productSelect.value)
  })

  hydrateChannelRowPicker(row)
  return row
}

function readChannelPriceIds (row) {
  const chipsEl = row.querySelector('.unlock-price-chips')
  if (!chipsEl) return []
  try {
    const parsed = JSON.parse(chipsEl.dataset.priceIds || '[]')
    return Array.isArray(parsed) ? parsed.filter(Boolean) : []
  } catch {
    return []
  }
}

function writeChannelPriceIds (row, priceIds) {
  const chipsEl = row.querySelector('.unlock-price-chips')
  if (!chipsEl) return
  chipsEl.dataset.priceIds = JSON.stringify(priceIds)
}

function formatCatalogPriceLabel (price) {
  if (!price) return 'Price'
  const amount = price.unit_amount == null
    ? null
    : formatMoney(price.unit_amount, price.currency)
  if (!amount) return price.nickname || price.id
  if (price.type === 'one_time') return `${amount} once`
  const interval = price.recurring && price.recurring.interval
  if (interval === 'year') return `${amount} / year`
  if (interval === 'month') return `${amount} / month`
  if (interval === 'week') return `${amount} / week`
  if (interval === 'day') return `${amount} / day`
  return amount
}

function findCatalogPrice (priceId) {
  for (const product of productCatalog.items) {
    const price = (product.prices || []).find((p) => p.id === priceId)
    if (price) return { product, price }
  }
  return null
}

function renderChannelPriceChips (row) {
  const chipsEl = row.querySelector('.unlock-price-chips')
  const emptyEl = row.querySelector('.unlock-price-empty')
  if (!chipsEl) return

  const priceIds = readChannelPriceIds(row)
  chipsEl.replaceChildren()

  for (const priceId of priceIds) {
    const match = findCatalogPrice(priceId)
    const chip = document.createElement('span')
    chip.className = 'unlock-price-chip'
    chip.title = priceId

    const label = document.createElement('span')
    label.className = 'unlock-price-chip__label'
    if (match) {
      label.textContent = `${match.product.name || 'Product'} · ${formatCatalogPriceLabel(match.price)}`
    } else {
      label.textContent = priceId
      chip.classList.add('unlock-price-chip--unknown')
    }

    const remove = document.createElement('button')
    remove.type = 'button'
    remove.className = 'unlock-price-chip__remove'
    remove.setAttribute('data-remove-price', priceId)
    remove.setAttribute('aria-label', `Remove ${priceId}`)
    remove.textContent = '×'

    chip.append(label, remove)
    chipsEl.appendChild(chip)
  }

  if (emptyEl) emptyEl.hidden = priceIds.length > 0
}

function fillChannelProductOptions (row) {
  const productSelect = row.querySelector('.unlock-price-product')
  if (!productSelect) return

  const previous = productSelect.value
  const products = productCatalog.items
    .filter((p) => p.active !== false && Array.isArray(p.prices) && p.prices.length > 0)
    .slice()
    .sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')))

  productSelect.replaceChildren()
  const placeholder = document.createElement('option')
  placeholder.value = ''
  placeholder.textContent = products.length ? 'Select product…' : 'No products with prices'
  productSelect.appendChild(placeholder)

  for (const product of products) {
    const option = document.createElement('option')
    option.value = product.id
    option.textContent = product.name || product.id
    productSelect.appendChild(option)
  }

  if (previous && products.some((p) => p.id === previous)) {
    productSelect.value = previous
  }
  fillChannelPriceOptions(row, productSelect.value)
}

function fillChannelPriceOptions (row, productId) {
  const priceSelect = row.querySelector('.unlock-price-price')
  const addBtn = row.querySelector('.unlock-price-add')
  if (!priceSelect || !addBtn) return

  const selectedIds = new Set(readChannelPriceIds(row))
  const product = productCatalog.items.find((p) => p.id === productId)
  const prices = product
    ? (product.prices || []).slice().sort((a, b) => (a.unit_amount || 0) - (b.unit_amount || 0))
    : []

  priceSelect.replaceChildren()
  const placeholder = document.createElement('option')
  placeholder.value = ''
  placeholder.textContent = productId ? 'Select price…' : 'Select price…'
  priceSelect.appendChild(placeholder)

  let available = 0
  for (const price of prices) {
    if (selectedIds.has(price.id)) continue
    available += 1
    const option = document.createElement('option')
    option.value = price.id
    option.textContent = formatCatalogPriceLabel(price)
    priceSelect.appendChild(option)
  }

  priceSelect.disabled = !productId || available === 0
  if (!productId) {
    placeholder.textContent = 'Select product first…'
  } else if (available === 0) {
    placeholder.textContent = prices.length ? 'All prices added' : 'No active prices'
  }
  addBtn.disabled = true
}

async function hydrateChannelRowPicker (row) {
  try {
    await loadProductCatalog()
  } catch (error) {
    console.warn('Failed to load product catalog for price picker', error)
  }
  fillChannelProductOptions(row)
  renderChannelPriceChips(row)
}

function refreshAllChannelPickers () {
  if (!unlockChannelsList) return
  unlockChannelsList.querySelectorAll('.unlock-channels-row').forEach((row) => {
    fillChannelProductOptions(row)
    renderChannelPriceChips(row)
  })
}

function escapeAttr (value) {
  return String(value == null ? '' : value).replace(/"/g, '&quot;')
}

function readFeaturesFromForm () {
  return Array.from(unlockFeaturesList.querySelectorAll('.unlock-features-row')).map((row) => ({
    label: row.querySelector('.unlock-feature-label').value.trim(),
    included: row.querySelector('.unlock-feature-included').checked
  })).filter((f) => f.label !== '')
}

function readChannelsFromForm () {
  return Array.from(unlockChannelsList.querySelectorAll('.unlock-channels-row')).map((row) => ({
    name: row.querySelector('.unlock-channel-name').value.trim(),
    minVersion: row.querySelector('.unlock-channel-min').value.trim(),
    priceIds: readChannelPriceIds(row)
  })).filter((c) => c.name !== '')
}

async function applyUnlockSettings (data) {
  const branding = data.branding || {}
  if (unlockExtensionName) unlockExtensionName.value = branding.extensionName || ''
  if (unlockTagline) unlockTagline.value = branding.tagline || ''
  if (unlockFooterNote) unlockFooterNote.value = branding.footerNote || ''
  if (unlockSuccessTitle) unlockSuccessTitle.value = branding.successTitle || ''
  if (unlockSuccessLead) unlockSuccessLead.value = branding.successLead || ''
  if (unlockSuccessHint) unlockSuccessHint.value = branding.successHint || ''
  renderHostedUnlockExperimentViews(data.experiments)
  applyButtonLabels(data.buttonLabels || {})
  applyFeatureUsageSettings(data.featureUsage)
  applyTrialSettings(data.trial)
  if (buttonSectionReady) {
    refreshButtonPreview()
  }

  unlockFeaturesList.replaceChildren()
  const features = Array.isArray(branding.features) ? branding.features : []
  if (features.length === 0) {
    unlockFeaturesList.appendChild(renderFeatureRow({ included: true }))
  } else {
    features.forEach((f) => unlockFeaturesList.appendChild(renderFeatureRow(f)))
  }

  unlockChannelsList.replaceChildren()
  const channels = Array.isArray(data.planChannels) ? data.planChannels : []
  if (channels.length === 0) {
    unlockChannelsList.appendChild(renderChannelRow({ name: 'default' }))
  } else {
    channels.forEach((c) => unlockChannelsList.appendChild(renderChannelRow(c)))
  }

  // Warm the catalog so chips resolve to product/price labels.
  loadProductCatalog()
    .then(() => refreshAllChannelPickers())
    .catch((error) => console.warn('Failed to hydrate channel price pickers', error))
}

async function saveUnlockSettings (event) {
  event.preventDefault()

  const form = event.target
  const submittingBtn = event.submitter || unlockSaveBtnForForm(form)
  const statusEl = unlockStatusForForm(form)
  setFormSaveState(submittingBtn, statusEl, 'loading')

  try {
    const body = form === trialUsageForm
      ? {
          trial: readTrialSettings(),
          featureUsage: readFeatureUsageSettings()
        }
      : {
          unlockContent: {
            extensionName: unlockExtensionName.value.trim(),
            tagline: unlockTagline.value.trim(),
            footerNote: unlockFooterNote.value.trim(),
            features: readFeaturesFromForm(),
            successTitle: unlockSuccessTitle ? unlockSuccessTitle.value.trim() : '',
            successLead: unlockSuccessLead ? unlockSuccessLead.value.trim() : '',
            successHint: unlockSuccessHint ? unlockSuccessHint.value.trim() : ''
          },
          planChannels: readChannelsFromForm()
        }
    const data = await apiRequest('/dashboard/unlock_settings', {
      method: 'PUT',
      body: JSON.stringify(body)
    })
    applyUnlockSettings(data)
    if (activeSection === 'product-catalog') loadHostedUnlockPreview({ force: true })
    if (activeSection === 'trial-usage') loadHostedFeatureUsagePreview({ force: true })
    if (activeSection === 'success') loadHostedUnlockSuccessPreview({ force: true })
    setFormSaveState(submittingBtn, statusEl, 'success')
  } catch (error) {
    setFormSaveState(submittingBtn, statusEl, 'error', error.message || 'Failed to save unlock settings.')
  }
}

const featureUsagePreviewFrame = document.getElementById('feature-usage-preview-frame')
const featureUsagePreviewLoading = document.getElementById('feature-usage-preview-loading')
const featureUsagePreviewOpen = document.getElementById('feature-usage-preview-open')
const featureUsagePreviewStatus = document.getElementById('feature-usage-preview-status')
let featureUsagePreviewHookScope = null
let featureUsagePreviewHookId = null
let featureUsagePreviewHookRequest = null
let featureUsagePreviewSequence = 0

function readFeatureUsageFormCaps () {
  return {
    weekly: featureUsageWeekly?.value,
    monthly: featureUsageMonthly?.value
  }
}

function refreshFeatureUsageEditor () {
  if (featureUsageCaps) {
    featureUsageCaps.classList.toggle('is-disabled', featureUsageEnabled?.checked !== true)
  }
  if (buttonSectionReady && activeSection === 'trial-usage') {
    loadHostedFeatureUsagePreview()
  }
}

function currentFeatureUsagePreviewScope () {
  return `${currentWorkspaceId || ''}:${getTestMode() ? 'test' : 'live'}`
}

async function resolveFeatureUsagePreviewHook ({ force = false } = {}) {
  const scope = currentFeatureUsagePreviewScope()
  if (!force && featureUsagePreviewHookScope === scope) {
    if (featureUsagePreviewHookRequest) return featureUsagePreviewHookRequest
    return featureUsagePreviewHookId
  }

  featureUsagePreviewHookScope = scope
  featureUsagePreviewHookId = null
  featureUsagePreviewHookRequest = apiRequest('/dashboard/payment_hooks?page=1')
    .then((data) => selectPreviewPaymentHook(data)?.id || null)
    .catch(() => null)
    .then((paymentHookId) => {
      if (featureUsagePreviewHookScope === scope) featureUsagePreviewHookId = paymentHookId
      return paymentHookId
    })
    .finally(() => {
      if (featureUsagePreviewHookScope === scope) featureUsagePreviewHookRequest = null
    })
  return featureUsagePreviewHookRequest
}

async function loadHostedFeatureUsagePreview ({ force = false } = {}) {
  if (!featureUsagePreviewFrame || !currentWorkspaceId) return
  const requestId = ++featureUsagePreviewSequence
  if (featureUsagePreviewLoading) featureUsagePreviewLoading.hidden = false
  featureUsagePreviewFrame.hidden = true

  const paymentHookId = await resolveFeatureUsagePreviewHook({ force })
  if (requestId !== featureUsagePreviewSequence) return

  const caps = readFeatureUsageFormCaps()
  const openUrl = buildHostedUsagePreviewUrl({
    paymentHookId,
    testMode: getTestMode(),
    feature: FEATURE_USAGE_KEY,
    weeklyLimit: caps.weekly,
    monthlyLimit: caps.monthly,
    unit: 'minute'
  })
  const previewUrl = new URL(openUrl)
  previewUrl.searchParams.set('previewRevision', String(requestId))
  featureUsagePreviewFrame.src = previewUrl.toString()
  if (featureUsagePreviewOpen) featureUsagePreviewOpen.href = openUrl
  if (featureUsagePreviewStatus) {
    const state = featureUsageEnabled?.checked
      ? 'Usage-based fallback is enabled.'
      : 'Usage-based fallback is disabled; this is a preview of the saved caps.'
    const branding = paymentHookId
      ? 'Branding comes from the latest install in this mode.'
      : 'Add an install in this mode to preview its branding and upgrade link.'
    featureUsagePreviewStatus.textContent = `${state} ${branding} Values shown are illustrative.`
  }
}

if (featureUsagePreviewFrame) {
  featureUsagePreviewFrame.addEventListener('load', () => {
    if (featureUsagePreviewLoading) featureUsagePreviewLoading.hidden = true
    featureUsagePreviewFrame.hidden = false
  })
}

const hostedUnlockPreviewFrame = document.getElementById('hosted-unlock-preview-frame')
const hostedUnlockPreviewLoading = document.getElementById('hosted-unlock-preview-loading')
const hostedUnlockPreviewEmpty = document.getElementById('hosted-unlock-preview-empty')
const hostedUnlockPreviewStatus = document.getElementById('hosted-unlock-preview-status')
const hostedUnlockPreviewOpen = document.getElementById('hosted-unlock-preview-open')
const hostedUnlockPreviewCountry = document.getElementById('hosted-unlock-preview-country')
const hostedUnlockPreviewExperiment = document.getElementById('hosted-unlock-preview-experiment')
let hostedUnlockPreviewKey = null
let hostedUnlockPreviewRequest = null
let hostedUnlockPreviewCatalog = null
let hostedUnlockPreviewPaymentHookId = null
let hostedUnlockPreviewRequestId = null
let hostedUnlockPreviewRequestSequence = 0

function currentHostedUnlockPreviewKey () {
  return buildHostedUnlockPreviewSelectionKey({
    workspaceId: currentWorkspaceId,
    testMode: getTestMode(),
    country: hostedUnlockPreviewCountry?.value || '',
    experimentView: hostedUnlockPreviewExperiment?.value || ''
  })
}

function renderHostedUnlockExperimentViews (experiments) {
  if (!hostedUnlockPreviewExperiment) return

  const previousValue = hostedUnlockPreviewExperiment.value
  const assignedOption = document.createElement('option')
  assignedOption.value = ''
  assignedOption.textContent = 'Assigned view (latest install)'
  hostedUnlockPreviewExperiment.replaceChildren(assignedOption)

  const views = listHostedUnlockExperimentViews(experiments)
  const groups = new Map()
  for (const view of views) {
    const groupKey = `${view.experimentId}:${view.experimentStatus}`
    let group = groups.get(groupKey)
    if (!group) {
      group = document.createElement('optgroup')
      group.label = `${view.experimentId} (${view.experimentStatus})`
      groups.set(groupKey, group)
      hostedUnlockPreviewExperiment.appendChild(group)
    }

    const option = document.createElement('option')
    option.value = view.value
    option.textContent = view.variantLabel
    group.appendChild(option)
  }

  hostedUnlockPreviewExperiment.value = views.some((view) => view.value === previousValue)
    ? previousValue
    : ''
  hostedUnlockPreviewExperiment.disabled = views.length === 0
}

function isCurrentHostedUnlockPreviewRequest (previewKey, requestId) {
  return isHostedUnlockPreviewRequestCurrent({
    selectionKey: currentHostedUnlockPreviewKey(),
    activeRequestId: hostedUnlockPreviewRequest?.requestId
  }, {
    key: previewKey,
    requestId
  })
}

function setHostedUnlockPreviewState ({ loading = false, message = '', openUrl } = {}) {
  if (hostedUnlockPreviewLoading) hostedUnlockPreviewLoading.hidden = !loading
  if (hostedUnlockPreviewEmpty) {
    hostedUnlockPreviewEmpty.textContent = message
    hostedUnlockPreviewEmpty.hidden = loading || !message
  }
  if (hostedUnlockPreviewStatus) {
    const countryLabel = hostedUnlockPreviewCountry?.selectedOptions?.[0]?.textContent
    const experimentLabel = hostedUnlockPreviewExperiment?.selectedOptions?.[0]?.textContent
    hostedUnlockPreviewStatus.textContent = loading
      ? 'Loading the published page…'
      : `Showing ${experimentLabel || 'the assigned experiment view'} with prices for ${countryLabel || 'the actual request location'}.`
  }
  if (hostedUnlockPreviewOpen && openUrl !== undefined) {
    hostedUnlockPreviewOpen.hidden = !openUrl
    if (openUrl) hostedUnlockPreviewOpen.href = openUrl
  }
  if (hostedUnlockPreviewFrame && (loading || message)) hostedUnlockPreviewFrame.hidden = true
}

function postHostedUnlockPreviewCatalog () {
  if (!hostedUnlockPreviewFrame?.contentWindow || !hostedUnlockPreviewCatalog || !hostedUnlockPreviewPaymentHookId || !hostedUnlockPreviewRequestId) return
  hostedUnlockPreviewFrame.contentWindow.postMessage({
    type: 'payhook:unlock-preview-catalog',
    paymentHookId: hostedUnlockPreviewPaymentHookId,
    requestId: hostedUnlockPreviewRequestId,
    catalog: hostedUnlockPreviewCatalog
  }, 'https://unlock.payhook.link')
}

async function loadHostedUnlockPreview ({ force = false } = {}) {
  if (!hostedUnlockPreviewFrame || !currentWorkspaceId) return

  const country = hostedUnlockPreviewCountry?.value || ''
  const experimentView = parseHostedUnlockExperimentView(hostedUnlockPreviewExperiment?.value)
  const previewKey = currentHostedUnlockPreviewKey()
  if (!force && hostedUnlockPreviewKey === previewKey && hostedUnlockPreviewFrame.src) return
  if (!force && hostedUnlockPreviewRequest?.key === previewKey) return hostedUnlockPreviewRequest.promise

  const requestId = `${Date.now()}-${++hostedUnlockPreviewRequestSequence}`
  setHostedUnlockPreviewState({ loading: true, openUrl: null })

  const promise = apiRequest('/dashboard/payment_hooks?page=1')
    .then(async (data) => {
      if (!isCurrentHostedUnlockPreviewRequest(previewKey, requestId)) return

      const hook = selectPreviewPaymentHook(data)
      if (!hook) {
        hostedUnlockPreviewKey = previewKey
        hostedUnlockPreviewCatalog = null
        hostedUnlockPreviewPaymentHookId = null
        hostedUnlockPreviewRequestId = null
        hostedUnlockPreviewFrame.removeAttribute('src')
        setHostedUnlockPreviewState({
          openUrl: null,
          message: 'A hosted preview will appear after this workspace has at least one install in the selected mode.'
        })
        return
      }

      const query = new URLSearchParams({ paymentHookId: hook.id })
      if (country) query.set('country', country)
      if (experimentView) {
        query.set('experimentId', experimentView.experimentId)
        query.set('experimentVariant', experimentView.variantName)
      }
      query.set('previewRequestId', requestId)
      const catalog = await apiRequest(`/dashboard/unlock_preview?${query}`, { cache: 'no-store' })
      if (!isCurrentHostedUnlockPreviewRequest(previewKey, requestId)) return

      const openUrl = buildHostedUnlockPreviewUrl({
        paymentHookId: hook.id,
        testMode: getTestMode()
      })
      const previewUrl = buildHostedUnlockPreviewUrl({
        paymentHookId: hook.id,
        testMode: getTestMode(),
        dashboardPreview: true,
        revision: requestId
      })
      hostedUnlockPreviewCatalog = catalog
      hostedUnlockPreviewPaymentHookId = hook.id
      hostedUnlockPreviewRequestId = requestId
      hostedUnlockPreviewKey = previewKey
      setHostedUnlockPreviewState({ loading: true, openUrl })
      hostedUnlockPreviewFrame.src = previewUrl
    })
    .catch((error) => {
      if (!isCurrentHostedUnlockPreviewRequest(previewKey, requestId)) return
      hostedUnlockPreviewKey = null
      hostedUnlockPreviewCatalog = null
      hostedUnlockPreviewPaymentHookId = null
      hostedUnlockPreviewRequestId = null
      setHostedUnlockPreviewState({ openUrl: null, message: error.message || 'Could not load the hosted preview.' })
    })
    .finally(() => {
      if (hostedUnlockPreviewRequest?.requestId === requestId) hostedUnlockPreviewRequest = null
    })

  hostedUnlockPreviewRequest = { key: previewKey, requestId, promise }
  return promise
}

if (hostedUnlockPreviewFrame) {
  hostedUnlockPreviewFrame.addEventListener('load', () => {
    if (!hostedUnlockPreviewFrame.src) return
    postHostedUnlockPreviewCatalog()
    setHostedUnlockPreviewState()
    hostedUnlockPreviewFrame.hidden = false
  })
}
window.addEventListener('message', (event) => {
  if (
    event.origin !== 'https://unlock.payhook.link' ||
    event.source !== hostedUnlockPreviewFrame?.contentWindow ||
    event.data?.type !== 'payhook:unlock-preview-ready' ||
    event.data?.requestId !== hostedUnlockPreviewRequestId
  ) return
  postHostedUnlockPreviewCatalog()
})
if (hostedUnlockPreviewCountry) {
  hostedUnlockPreviewCountry.addEventListener('change', () => {
    hostedUnlockPreviewKey = null
    loadHostedUnlockPreview({ force: true })
  })
}
if (hostedUnlockPreviewExperiment) {
  hostedUnlockPreviewExperiment.addEventListener('change', () => {
    hostedUnlockPreviewKey = null
    loadHostedUnlockPreview({ force: true })
  })
}
if (unlockForm) unlockForm.addEventListener('submit', saveUnlockSettings)
if (unlockCatalogForm) {
  unlockCatalogForm.addEventListener('submit', saveUnlockSettings)
}
if (unlockFeaturesForm) {
  unlockFeaturesForm.addEventListener('submit', saveUnlockSettings)
}
if (trialUsageForm) {
  trialUsageForm.addEventListener('submit', saveUnlockSettings)
  trialUsageForm.addEventListener('input', () => {
    refreshTrialSettingsEditor()
    refreshFeatureUsageEditor()
  })
  trialUsageForm.addEventListener('change', () => {
    refreshTrialSettingsEditor()
    refreshFeatureUsageEditor()
  })
}
if (unlockFeaturesAdd) {
  unlockFeaturesAdd.addEventListener('click', () => {
    unlockFeaturesList.appendChild(renderFeatureRow({}))
  })
}
if (unlockChannelsAdd) {
  unlockChannelsAdd.addEventListener('click', () => {
    unlockChannelsList.appendChild(renderChannelRow({ name: 'default' }))
  })
}

// ── Unlock success ──────────────────────────────────────────────────────────

const unlockSuccessForm = document.getElementById('unlock-success-form')
const unlockSuccessTitle = document.getElementById('unlock-success-title')
const unlockSuccessLead = document.getElementById('unlock-success-lead')
const unlockSuccessHint = document.getElementById('unlock-success-hint')

const hostedUnlockSuccessPreviewFrame = document.getElementById('hosted-unlock-success-preview-frame')
const hostedUnlockSuccessPreviewLoading = document.getElementById('hosted-unlock-success-preview-loading')
const hostedUnlockSuccessPreviewEmpty = document.getElementById('hosted-unlock-success-preview-empty')
const hostedUnlockSuccessPreviewStatus = document.getElementById('hosted-unlock-success-preview-status')
const hostedUnlockSuccessPreviewOpen = document.getElementById('hosted-unlock-success-preview-open')
let hostedUnlockSuccessPreviewKey = null
let hostedUnlockSuccessPreviewRequest = null

function setHostedUnlockSuccessPreviewState ({ loading = false, message = '', url } = {}) {
  if (hostedUnlockSuccessPreviewLoading) hostedUnlockSuccessPreviewLoading.hidden = !loading
  if (hostedUnlockSuccessPreviewEmpty) {
    hostedUnlockSuccessPreviewEmpty.textContent = message
    hostedUnlockSuccessPreviewEmpty.hidden = loading || !message
  }
  if (hostedUnlockSuccessPreviewStatus) {
    hostedUnlockSuccessPreviewStatus.textContent = loading ? 'Loading published page…' : 'Published page'
  }
  if (hostedUnlockSuccessPreviewOpen && url !== undefined) {
    hostedUnlockSuccessPreviewOpen.hidden = !url
    if (url) hostedUnlockSuccessPreviewOpen.href = url
  }
  if (hostedUnlockSuccessPreviewFrame && (loading || message)) hostedUnlockSuccessPreviewFrame.hidden = true
}

async function loadHostedUnlockSuccessPreview ({ force = false } = {}) {
  if (!hostedUnlockSuccessPreviewFrame || !currentWorkspaceId) return

  const previewKey = `${currentWorkspaceId}:${getTestMode() ? 'test' : 'live'}`
  if (!force && hostedUnlockSuccessPreviewKey === previewKey && hostedUnlockSuccessPreviewFrame.src) return
  if (!force && hostedUnlockSuccessPreviewRequest?.key === previewKey) return hostedUnlockSuccessPreviewRequest.promise

  setHostedUnlockSuccessPreviewState({ loading: true, url: null })
  const promise = apiRequest('/dashboard/payment_hooks?page=1')
    .then((data) => {
      if (`${currentWorkspaceId}:${getTestMode() ? 'test' : 'live'}` !== previewKey) return
      const hook = selectPreviewPaymentHook(data)
      if (!hook) {
        hostedUnlockSuccessPreviewKey = previewKey
        hostedUnlockSuccessPreviewFrame.removeAttribute('src')
        setHostedUnlockSuccessPreviewState({
          url: null,
          message: 'A hosted preview will appear after this workspace has at least one install in the selected mode.'
        })
        return
      }

      const url = buildHostedUnlockSuccessPreviewUrl({
        paymentHookId: hook.id,
        testMode: getTestMode(),
        revision: force ? Date.now() : undefined
      })
      hostedUnlockSuccessPreviewKey = previewKey
      setHostedUnlockSuccessPreviewState({ loading: true, url })
      hostedUnlockSuccessPreviewFrame.src = url
    })
    .catch((error) => {
      if (`${currentWorkspaceId}:${getTestMode() ? 'test' : 'live'}` !== previewKey) return
      hostedUnlockSuccessPreviewKey = null
      setHostedUnlockSuccessPreviewState({ url: null, message: error.message || 'Could not load the hosted success preview.' })
    })
    .finally(() => {
      if (hostedUnlockSuccessPreviewRequest?.promise === promise) hostedUnlockSuccessPreviewRequest = null
    })

  hostedUnlockSuccessPreviewRequest = { key: previewKey, promise }
  return promise
}

if (hostedUnlockSuccessPreviewFrame) {
  hostedUnlockSuccessPreviewFrame.addEventListener('load', () => {
    if (!hostedUnlockSuccessPreviewFrame.src) return
    setHostedUnlockSuccessPreviewState()
    hostedUnlockSuccessPreviewFrame.hidden = false
  })
}

if (unlockSuccessForm) {
  // Same endpoint as the Unlock page form — both write to unlockContent.
  unlockSuccessForm.addEventListener('submit', saveUnlockSettings)
}

// ── Unlock button labels + preview ──────────────────────────────────────────
// Labels map to UpgradeButton states via accountSettings.buttonLabels →
// GET /v1/config.labels. Color still comes from Branding.

const DEFAULT_BUTTON_LABELS = {
  upgrade: 'Upgrade',
  manage: 'Manage plan',
  trial: 'Trial',
  trialEnded: 'Upgrade',
  usage: 'Usage',
  usageHit: 'Limit reached'
}

const buttonLabelsForm = document.getElementById('button-labels-form')
const buttonLabelsSaveBtn = document.getElementById('button-labels-save-btn')
const buttonLabelsStatus = document.getElementById('button-labels-status')
const btnLabelUpgrade = document.getElementById('btn-label-upgrade')
const btnLabelManage = document.getElementById('btn-label-manage')
const btnLabelTrial = document.getElementById('btn-label-trial')
const btnLabelTrialEnded = document.getElementById('btn-label-trial-ended')
const btnLabelUsage = document.getElementById('btn-label-usage')
const btnLabelUsageHit = document.getElementById('btn-label-usage-hit')
const btnPreviewUpgrade = document.getElementById('btn-preview-upgrade')
const btnPreviewManage = document.getElementById('btn-preview-manage')
const btnPreviewTrial = document.getElementById('btn-preview-trial')
const btnPreviewTrialEnded = document.getElementById('btn-preview-trial-ended')
const btnPreviewUsage = document.getElementById('btn-preview-usage')
let sdkButtonPreview = null

function currentButtonLabels () {
  return {
    upgrade: resolveButtonLabel('upgrade'),
    manage: resolveButtonLabel('manage'),
    trial: resolveButtonLabel('trial'),
    trialEnded: resolveButtonLabel('trialEnded'),
    usage: resolveButtonLabel('usage'),
    usageHit: resolveButtonLabel('usageHit')
  }
}

function ensureSdkButtonPreview () {
  if (sdkButtonPreview) return sdkButtonPreview

  try {
    sdkButtonPreview = mountSdkButtonPreview({
      UpgradeButton: window.Payhook?.UpgradeButton,
      roots: {
        upgrade: btnPreviewUpgrade,
        manage: btnPreviewManage,
        trial: btnPreviewTrial,
        trialEnded: btnPreviewTrialEnded,
        usage: btnPreviewUsage
      },
      labels: currentButtonLabels()
    })
  } catch (error) {
    console.warn('Could not mount Payhook SDK button preview.', error)
  }

  return sdkButtonPreview
}

function applyButtonLabels (labels = {}) {
  if (btnLabelUpgrade) btnLabelUpgrade.value = labels.upgrade || ''
  if (btnLabelManage) btnLabelManage.value = labels.manage || ''
  if (btnLabelTrial) btnLabelTrial.value = labels.trial || ''
  if (btnLabelTrialEnded) btnLabelTrialEnded.value = labels.trialEnded || ''
  if (btnLabelUsage) btnLabelUsage.value = labels.usage || ''
  if (btnLabelUsageHit) btnLabelUsageHit.value = labels.usageHit || ''
  renderUnlockButtonHomePreview()
}

function readButtonLabelsFromForm () {
  const labels = {}
  const pairs = [
    ['upgrade', btnLabelUpgrade],
    ['manage', btnLabelManage],
    ['trial', btnLabelTrial],
    ['trialEnded', btnLabelTrialEnded],
    ['usage', btnLabelUsage],
    ['usageHit', btnLabelUsageHit]
  ]
  pairs.forEach(([key, input]) => {
    const value = input?.value?.trim() || ''
    if (value) labels[key] = value
  })
  return labels
}

function resolveButtonLabel (key) {
  const custom = {
    upgrade: btnLabelUpgrade?.value,
    manage: btnLabelManage?.value,
    trial: btnLabelTrial?.value,
    trialEnded: btnLabelTrialEnded?.value,
    usage: btnLabelUsage?.value,
    usageHit: btnLabelUsageHit?.value
  }[key]
  return (custom && custom.trim()) || DEFAULT_BUTTON_LABELS[key] || ''
}

function renderUnlockButtonHomePreview () {
  const root = document.getElementById('ext-button-preview')
  if (!root) return

  const labels = currentButtonLabels()
  const sdkPreview = ensureSdkButtonPreview()
  if (sdkPreview) {
    sdkPreview.updateLabels(labels)
    return
  }

  const fallbackButtons = {
    upgrade: btnPreviewUpgrade?.querySelector('button'),
    manage: btnPreviewManage?.querySelector('button'),
    trial: btnPreviewTrial?.querySelector('button'),
    trialEnded: btnPreviewTrialEnded?.querySelector('button'),
    usage: btnPreviewUsage?.querySelector('button')
  }
  Object.entries(fallbackButtons).forEach(([key, button]) => {
    if (button) button.textContent = labels[key]
  })
}

function refreshButtonPreview () {
  if (!buttonSectionReady) return
  renderUnlockButtonHomePreview()
}

async function saveButtonLabels (event) {
  event.preventDefault()
  if (!buttonLabelsSaveBtn) return

  setFormSaveState(buttonLabelsSaveBtn, buttonLabelsStatus, 'loading')
  try {
    const data = await apiRequest('/dashboard/unlock_settings', {
      method: 'PUT',
      body: JSON.stringify({ buttonLabels: readButtonLabelsFromForm() })
    })
    applyButtonLabels(data.buttonLabels || {})
    setFormSaveState(buttonLabelsSaveBtn, buttonLabelsStatus, 'success')
  } catch (error) {
    setFormSaveState(buttonLabelsSaveBtn, buttonLabelsStatus, 'error', error.message || 'Failed to save button labels.')
  }
}

if (buttonLabelsForm) {
  buttonLabelsForm.addEventListener('submit', saveButtonLabels)
  buttonLabelsForm.addEventListener('input', renderUnlockButtonHomePreview)
}

if (productCatalogTabsNavEl) {
  productCatalogTabsNavEl.addEventListener('click', (event) => {
    const btn = event.target.closest('.settings-tabs__btn')
    if (!btn || !btn.dataset.catalogTab) return
    const tab = btn.dataset.catalogTab
    activateCatalogTab(tab)
    setCatalogTabInUrl(tab)
    if (activeSection === 'product-catalog') {
      showProductCatalogPreview()
    }
  })
}

function initActionButtons () {
  ;[
    authSubmitBtn,
    headerDisconnectBtn,
    settingsSaveBtn,
    brandingSaveBtn,
    unlockSaveBtn,
    unlockCatalogSaveBtn,
    unlockFeaturesSaveBtn,
    trialUsageSaveBtn,
    unlockSuccessSaveBtn,
    buttonLabelsSaveBtn,
    createHookBtn,
    hookFetchBtn,
    paymentFetchBtn,
    apiKeysCreateBtn
  ].forEach(initActionButton)
}

if (isEmbedMode()) document.body.classList.add('embed-mode')

initActionButtons()
bootstrap()
